import { Component, OnInit, ViewContainerRef, ElementRef, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { FormBuilder, FormGroup, Validators, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { CompositeArrayComponent } from 'src/modules/base/components/composite-array/composite-array.component';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BillingpopupComponent } from 'src/modules/billing/components/billingpopup/billingpopup.component';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import moment from 'proxies/dayjs';
import { Injector } from '@angular/core';
import { FormService } from 'src/modules/base/components/form/form.service';
import BaseDecorator from 'src/modules/base/base-decorator';
import { FieldGroup } from 'src/modules/base/components/form/models/field-group.model';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { SearchAndSelect } from 'src/modules/base/components/form/models/serachselect.model';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import PaymentModeFlagsDecorator from 'src/decorators/payment_mode_flags_decorator';

@Component({
    selector: 'app-payment-detail-edit-bill',
    templateUrl: './payment-detail-edit-bill.component.html',
    styleUrls: ['./payment-detail-edit-bill.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: PaymentDetailEditBillComponent,
            multi: true,
        }],
    standalone: false
})

export class PaymentDetailEditBillComponent extends BaseDecorator implements OnInit, OnDestroy {
  @Input() _value: any;
  @Input() config: any = {};
  dataSet: any;
  scheme_idd: any;
  deposit_arg: any;
  objval: any;
  value_data: any;
  schm_rmvd: boolean = false;
  public form: FormGroup;
  addedAmount: any;
  public formService: FormService;
  self: any;
  rec_uhId: any;
  rec_employeeId: any;
  due_config: any;
  rec_name: any;
  schemedatasource: any;
  recoveryData: any;
  discountchecked: boolean = true;
  @ViewChild('multiselectscheme') multiselectscheme: any;
  @Input() createDisable: boolean = false;
  bookDisable: boolean = false;
  draftDisable: boolean = false;
  openAccordian: boolean = true;
  blockMapping: FieldGroup[];
  activeKey: any; override_config: boolean = false;
  navVar: any = [{ field_name: "bill_summary", heading: "Billing Summary", block_id: "bill_summary", default_open: true, show: true },
  { field_name: "discount", heading: "Discount", block_id: "discount", default_open: false, show: true },
  { field_name: "deposit", heading: "Deposit", block_id: "deposit", default_open: false, show: true },
  { field_name: "advance", heading: "Advance", block_id: "advance", default_open: false, show: false },
  { field_name: "payment_details", heading: "Payment Details", block_id: "payment_details", default_open: true, show: true },
  { field_name: "due", heading: "Due", block_id: "due", default_open: false, show: true },
  { field_name: "delivery_charges", heading: "Delivery Charges", block_id: "delivery_charges", default_open: false, show: true },
  { field_name: "remarks", heading: "Remarks", block_id: "remarks", default_open: false, show: true }]
  is_advance_checked: boolean = false;
  is_discount_checked: boolean = false;
  scheme_selected: boolean = false; otp_id_due: any; otp_id_discount: any;
  patientInfo: any = {}
  book_config: any;
  @ViewChild('compositeArrayComponent') compositeArrayComponent: CompositeArrayComponent;
  otp_visibility: boolean;
  time_for_otp_reset: boolean;
  is_previous_paid: any;
  question: any;
  otptimeout: any;
  visible_is_due: boolean;
  visible_is_checked: boolean = false;
  duplicatePaymentConfigResult: any;
  adding: number;
  pos_transaction_id: any;
  payment_gateway_cancel_response: any;
  wkflow_called: boolean = false;
  payment_details_array: any;
  showPaymentdeails: boolean = true; //to show payment details
  showDeposit: boolean = true;//to show deposit
  discountData: any; dueName: any; //discount data due data
  defaultsetting: any;
  configValueDecimal: string = "Yes";
  changeDueAmountDecimal: boolean = false;
  formObject: any;
  is_ovrride:boolean = true;
  remark_mandatory_config_value: any;
  discount_remark_mandatory_config_value: boolean;
  due_remark_mandatory_config_value: boolean;
  CompositeObj: any;
  paymentTransactionDetails: any;
  disableEditBillButton: any;
  enablePaymentMode: boolean;
  paymentTotalEditable: number;
  
  @Input()
  public set value(v: any) {
    if (v) {
      this._value = v;
    } else {
      this._value = '';
    }
  }
  @Input() public set remarks(remarks: any) {
    this.paymentForm.controls['remarks'].setValue(remarks);
  }
  @Input() public set disableUpdateBillButton(editBillButton:any){
    this.disableEditBillButton = editBillButton;
  }
  @Input() public set orderdata(valueorder: any) {
    this.value_data = valueorder;
    this.paymentTotalEditable = 0;
    if(this.value_data){
      if(this.value_data.bill_no!=undefined) {
        this.callForPaymentDetails(this.value_data.bill_no)
       }
      if(this.value_data.services!=undefined && this.value_data.services.length > 0){
        this.value_data.services.forEach(element => {
          if(element['service_modify_type'] == 'A'){
            this.enablePaymentMode = true
            this.paymentTotalEditable += element.total_amount;
          }
        });
      }
    }
     

    // this.paymentForm.controls['is_discount'].setValue(true);
    //  this.amounts.is_discount=true;
    // this.paymentForm.controls['is_discount'].setValue(true);
    // this.paymentForm.controls['type'].setValue(valueorder.type);
    // this.paymentForm.controls['discount_on'].setValue(valueorder.discount_on);
    // this.paymentForm.controls['discount_type'].setValue(valueorder.discount_type);
    // this.paymentForm.controls['discount_value'].setValue(valueorder.discount_value);
    // this.paymentForm.controls['discount_authorized_by'].setValue(valueorder.authorized_by_id);
  }
  callForPaymentDetails(billno:any){
    if(billno!=undefined){
      let data = {
        "args": "transaction_id:" + billno + ",noCount:1",
        "query_id": "GET_PAYMENT_DETAILS_FOR_EDIT_BILL",
        page_size: 10
      }
      this.baseService.getData(data, "", 'payment_transaction_details', 'payment', 'GET_PAYMENT_DETAILS_FOR_EDIT_BILL').subscribe(
        dataRes => {
          if (dataRes.errCode == 0) {
            this.paymentTransactionDetails = dataRes.resource;
            if(this.paymentTransactionDetails.length > 0){
              // this.paymentForm.controls['payment_detail'].value.push(this.paymentTransactionDetails);
              this.paymentForm.controls['payment_detail'].setValue(this.paymentTransactionDetails);
            }
            // this.paymentForm.controls['payment_detail'].setValue(this.paymentTransactionDetails);
            // this.onPaymentAddForEditBill(this.paymentTransactionDetails);
            
          }
          });
    }
  }
  @Input() public set dataPay(value: any) {
    if (value && value.hasOwnProperty('hide_sections') && this.navVar.length > 0) {
      if(value.ovrride_hide)
      this.is_ovrride = false;
      for (let f of this.navVar) {
        if (f.block_id == 'discount' && value.hasOwnProperty('discount_component')) {
          f.show = value.discount_component;
        }
        if (f.block_id == 'deposit' && value.hasOwnProperty('deposite_component')) {
          f.show = value.deposite_component;
        }
        if (f.block_id == 'advance' && value.hasOwnProperty('advance_component')) {
          f.show = value.advance_component;
        }
        if (f.block_id == 'due' && value.hasOwnProperty('due_component')) {
          f.show = value.due_component;
        }
        if (f.block_id == 'remarks' && value.hasOwnProperty('remarks_component')) {
          f.show = value.remarks_component;
        }
        if (f.block_id == 'delivery_charges' && value.hasOwnProperty('charges_component')) {
          f.show = value.charges_component;
        }
      }
    }
    if (value && value.remark_mandatory_config_value) {
      value.remark_mandatory_config_value.find(e => {
        if (e.id == 'discount') {
          this.discount_remark_mandatory_config_value = true;
        }
        if (e.id == 'due') {
          this.due_remark_mandatory_config_value = true;
        }
      });
    }
    if (value && value.not_disable == true) {
      this.createDisable = false;
    }
    if (value && !value.not_disable) {

      if (value.err && value.transaction_type == 'OP Billing') {
        this.createDisable = false;
        this.bookDisable = false;
        this.draftDisable = false;
        this.dataSet = value;
      }
      else {
        // this.counter +=1;
        if (value.transaction_type != undefined) {
          if (value.transaction_type == 'OP Billing')
            this.deposit_arg = 'op_billing';
          else if (value.transaction_type == 'Ambulance Billing')
            this.deposit_arg = 'ambulance_billing';
          else if (value.transaction_type == 'Pharmacy Billing')
            this.deposit_arg = 'pharmacy_billing';
          else if (value.transaction_type == 'optical billing')
            this.deposit_arg = 'optical_billing';
          else
            this.deposit_arg = "";
        }
        if (value.consumed_amount && value.is_previous_paid) {
          this.paymentForm.controls['consumed_amount'].setValue(value.consumed_amount);
          this.is_previous_paid = true
        }
        else {
          this.is_previous_paid = false
        }

        this.dataSet = value;
        console.log("this.dataset", this.dataSet)
        let payAmount = 0;
        this.patientInfo['uhId'] = value.uhId;
        this.patientInfo['patient_type'] = value.patient_type;
        this.patientInfo['gender'] = value.gender;
        if (value.checked && this.discountchecked) {// Update payment component from external resources

          this.amounts.is_discount = true;
          //this condition is made optical specific so that it does not affect other appliation this condition can be removed if there is a need to set discount
          if (this.paymentForm != undefined && this.paymentForm.controls != undefined && this.paymentForm.controls['is_discount'] != undefined && this.config != undefined && this.config.application != undefined && this.config.application == 'optical') {
            this.paymentForm.controls['is_discount'].setValue(true);
            this.paymentForm.controls['discount_authorized_by'].setValue(value.authorized_by_id != undefined ? value.authorized_by_id : value.discount_authorized_by_id != undefined ? value.discount_authorized_by_id : "");
            this.paymentForm.controls['discount_authorized_by_id'].setValue(value.authorized_by_id != undefined ? value.authorized_by_id : value.discount_authorized_by_id != undefined ? value.discount_authorized_by_id : "");
            if (value.discount_on != undefined && value.discount_on == "service_item") {
              this.visibility.disableDiscountValue = true;
            }
            if(value.schemeId != this.paymentForm.controls['scheme'].value)
            this.schemeSetup(value);
          }
          this.visibility.disableField = false;
          this.paymentForm.patchValue(value);
          if (this.visibility.schemeVisible) {
            this.paymentForm.controls['type'].setValue('scheme');
          }
          else {
            this.paymentForm.controls['type'].setValue('direct');
          }
        }
        //for advance payment
        if (value.advance_payment != undefined && value.advance_payment) {
          this.paymentForm.patchValue({ is_default_amount: value.paid_amount != undefined ? value.paid_amount : null, advance_payment: value.paid_amount ? true : false});
          this.is_advance_checked = true;
          this.paymentForm.controls['is_default_amount'].disable();
          this.paymentForm.controls['advance_payment'].disable();
          // this.checkAdvance()
          this.navVar.find(x => x.field_name == "advance").default_open = true;
        }

        if (value.patient_amount) {
          payAmount = value.patient_amount;
        } else {
          payAmount = value.net_amount - value.payer_amount;
        }
        if (this.paymentForm.controls['net_receivable_amount'].value!=null && (value.final_amount != this.paymentForm.controls['net_receivable_amount'].value) && (value.type == undefined || value.type || value.type.index)) {
          this.resetAllData(value);
          this.showPaymentdeails = true;
          if ((this.dueName && (this.dueName.workflow_stage == "single_stage" || this.dueName.workflow_stage == "multi_stage")) || (this.discountData && (this.discountData.workflow_stage == "single_stage" || this.discountData.workflow_stage == "multi_stage") && (value && value.op_amount_value && value.op_amount_value.discount_value))) {
            this.showPaymentdeails = false;
          }
        }
        if(this.paymentForm.controls['is_due'].value && this.paymentForm.controls['due_amount'].value>0 && value.authorized_amount==this.paymentForm.controls['net_amount'].value){
          //this.paymentForm.controls['due_amount'].setValue(0);
          this.resetDueCheckbox();
          this.showPaymentdeails = true;
        }
        this.paymentForm.patchValue({total_amount: value.amount, discount: value.discount, net_amount: value.net_amount, tax: value.tax, patient_amount: payAmount, net_receivable_payer_amount: value.payer_amount, authorised_amount: value.authorized_amount, net_receivable_amount: value.final_amount, final_amount: value.final_amount });
        if (value.type != undefined && (value.type == 'payerChange' || value.type == 'error' || value.type.index)) {
          this.resetAllData(value);
          this.showPaymentdeails = true;
        }
        this.bindDropDownsFormExternalResources(); //added for discount
        this.getDepositAmount();
        this.addedresourceInfo();
        //console.log("this.countr",this.counter)
        this.OnPaymentAdd({ type: true });
      }
    }
  };
  @Output() serviceDiscount = new EventEmitter<any>();
  @Output() deliveryCharges = new EventEmitter<any>();
  @Output() createBillButton = new EventEmitter<any>();
  @Output() authoriseDetail = new EventEmitter<any>();
  // bannerJson: any = false; //not in use
  payment_detail: any;
  dueApiSignature = {
    application: "facility-management",
    resource: "workflow_master_setup",
    query_id: "GET_DATA_OF_WORKFLOW",
    args: ""
  };
  discountApiSignature = {
    application: "facility-management",
    resource: "workflow_master_setup",
    query_id: "GET_DATA_OF_WORKFLOW",
    args: ""
  }
  discountTypeApi = {
    "application": "system-management",
    "resource": "valueset",
    "query_id": "get_valueset_by_id_flat",
    "args": "resourceId:discount_type,system:karexpert",
  }
  reasonTypeDiscountApi = {
    "application": "facility-management",
    "resource": "facility_master",
    "query_id": "getReasonNameBasedOnReasonType",
    "args": "facility_master_type:REASON,reasontype_id:discount",
  }
  reasonTypeDueApi = {
    "application": "facility-management",
    "resource": "facility_master",
    "query_id": "getReasonNameBasedOnReasonType",
    "args": "facility_master_type:REASON,reasontype_id:due",
  }
  discTypeApiSignature = {
    application: "system-management",
    resource: "valueset",
    query_id: "get_valueset_by_id_flat",
    args: "resourceId:valueType,system:karexpert",
  }
  discOnApiSignature = {
    application: "system-management",
    resource: "valueset",
    query_id: "get_valueset_by_id_flat",
    args: "resourceId:discount_on,system:karexpert",
  }
  depositApi = {
    resource: "deposit_wallet",
    application: "payment",
    query_id: "GET_TOTAL_DEPOSIT_BY_UHID",
  }

  schemeApiSignature = {
    "application": "facility-management",
    "resource": "scheme_detail",
    "query_id": "GET_SCHEME_DETAILS"
  }
  paymentForm: FormGroup;
  amounts: any = {}
  responses: any = {}
  visibility: any = {}
  mainmulti = {
    datasource: {
      "application": "patient-registration",
      "resource": "patient",
      "query_id": "GET_EMPLOYEES_LIST",
      "args": "employee:Employee,noCount:1"
    },
    controls: {
      recovery: {
        value: ""
      }
    },
    question: {
      defaultsetting: {
        "singleSelection": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": false
      },
      getterKey: "id",
      format: "(item) => `${item.patient_name} || ${item.emp_no}`",
      getterValue: "patient_name",
      "req_keys": [
        "id",
        "patient_name",
        "emp_no",
        "name",
        "uhId"
      ],
      key: "recovery"
    },
    defaultsetting: {
      "singleSelection": true,
      "checkBoxRequired": false,
      "closeDropDownOnSelection": true,
      "apliCall": true
    }
  }

  reasonmulti = {
    "datasource": {
      "application": "facility-management",
      "resource": "facility_master",
      "query_id": "getReasonNameBasedOnReasonType",
      "args": "facility_master_type:REASON,reasontype_id:due",
      "key": "id"
    },
    controls: {
      due_reason: {
        value: ""
      }
    },
    question: {
      "getterKey": "name",
      "getterValue": "name",
      "req_keys": ["name"]
    },
    defaultsetting: {
      "singleSelection": true,
      "checkBoxRequired": false,
      "closeDropDownOnSelection": true,
      "apliCall": false
    }
  }
  schemeresource: any;
  itemresource: any;
  discountmultireason = {
    "datasource": {
      "application": "facility-management",
      "resource": "facility_master",
      "query_id": "getReasonNameBasedOnReasonType",
      "args": "facility_master_type:REASON,reasontype_id:discount",
      "key": "id"
    },
    controls: {
      due_reason: {
        value: ""
      }
    },
    question: {
      "getterKey": "name",
      "getterValue": "name",
      "req_keys": ["name"]
    },
    defaultsetting: {
      "singleSelection": true,
      "checkBoxRequired": false,
      "closeDropDownOnSelection": true,
      "apliCall": false
    }
  }

  constructor(public baseService: BaseService,
    public fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public loader: LoaderService,
    public utilService: UtilService,
    public injector: Injector,
    public containerRef?: ViewContainerRef,
    public alertService?: AlertsService,
    public appService?: AppService,
    public elementRef?: ElementRef,
    public rolePermissionService?: RolePermissionService,
    public preferenceService?: PreferenceService
    ) {
    super(activatedRoute, 'PaymentDetailComponent', injector);
    this.self = this;
    if (injector != undefined && injector.get != undefined) {
      this.formService = injector.get(FormService);
      this.baseService = injector.get(BaseService);
    }
    this.paymentForm = new FormGroup({
      'total_amount': new FormControl(),
      'discount': new FormControl(0),
      'tax': new FormControl(0),
      'net_amount': new FormControl(),
      'received_amount': new FormControl(),
      'net_receivable_amount': new FormControl(),
      'authorised_amount': new FormControl(),
      'patient_amount': new FormControl(),
      'final_amount': new FormControl(),
      'consumed_amount': new FormControl(),
      'net_receivable_payer_amount': new FormControl(0),
      'is_used_deposit': new FormControl(false),
      'deposit_amount': new FormControl({ value: 0, disabled: true }),
      'used_deposit_amount': new FormControl(0),
      'is_discount': new FormControl(false),
      'type': new FormControl(''),
      "override_scheme": new FormControl(false),
      'discount_reason': new FormControl(''),
      'discount_type': new FormControl('amount'),
      'discount_on': new FormControl(''),
      'discount_value': new FormControl(0, Validators.min(0)),
      'discount_authorized_by': new FormControl(''),
      'discount_authorized_by_id': new FormControl(''),
      'discount_authorized_by_name': new FormControl(''),
      'payment_detail': new FormControl([]),
      'is_due': new FormControl(false),
      'item_charges': new FormControl(false),
      'item_name': new FormControl(''),
      'noOfInstallment': new FormControl(),
      'recovery': new FormControl(''),
      'due_reason': new FormControl(''),
      'due_amount': new FormControl(0),
      'due_authorised_by_id': new FormControl(''),
      'due_authorised_by_name': new FormControl(''),
      'remarks': new FormControl(''),
      'scheme': new FormControl(''),
      'scheme_name': new FormControl(''),
      'deposit_wallet_id': new FormControl(),
      'otp': new FormControl(),
      'is_default_amount': new FormControl(0),
      'advance_payment': new FormControl(false),
      'is_visible': new FormControl(false),
      'payment_enable': new FormControl(false),
      'otp_due': new FormControl()
    })
  }
  resetAllData(value) {
    // this.showPaymentdeails = true;
    if (this.paymentForm.controls['payment_detail'] && this.paymentForm.controls['payment_detail'].value && this.paymentForm.controls['payment_detail'].value.length > 0) {
      if (this.compositeArrayComponent) {
        this.compositeArrayComponent.removeAllItems();
        this.paymentForm.controls['payment_detail'].setValue([]);
      }
    }
    this.resetDueCheckbox();
    this.paymentForm.controls['is_used_deposit'].setValue(false);
    this.visibility.enableUseDepositAmt = true;
    this.amounts.is_used_deposit = false;
    this.paymentForm.controls['used_deposit_amount'].setValue(0);
    if ((value.scheme_id != undefined || value.schemeId != undefined) && ((value.scheme_id || value.schemeId) || (this.responses.schemeResponse != undefined && this.dataSet.transaction_type == 'OP Billing'))) {
      this.visibility.schemeVisible = true;
      this.visibility.disableField = false;
      this.amounts.is_discount = true;
      this.visibility.discountFieldVisible = false;
      this.paymentForm.controls['is_discount'].setValue(true);
      this.bindDropDownsFormExternalResources('scheme');
      this.paymentForm.controls['type'].setValue('scheme');
      if (this.dataSet && this.dataSet.transaction_type && this.dataSet.transaction_type == "OP Billing") {
        if (this.appService.getUniversalConfig('multi_care_type')) {
          this.schemeApiSignature['args'] = "care_type:" + this.appService.getDynamicFunctions("getCurrentCareType")
        }
      }
      if (this.responses.schemeResponse != undefined && (this.dataSet.transaction_type == 'OP Billing' || this.dataSet.transaction_type == 'Pharmacy Billing')) {
        value['id'] = value.scheme_id;
        if (value.scheme_discount_applicable && value.scheme_id != this.paymentForm.controls['scheme'].value) {
          this.formService.blockMapping[1]['default_open'] = true;
          this.paymentForm.controls['type'].setValue('scheme');
          this.visibility.schemeVisible = true;
          this.paymentForm.controls['scheme'].setValue(value.scheme_id);
          this.paymentForm.controls['scheme_name'].setValue(value.scheme_name);
          this.schemeresource.datasource.args = "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + ((this.value_data && this.value_data.payer_details && this.value_data.payer_details.payer_id) ? this.value_data.payer_details.payer_id : '')
          setTimeout(() => {
            if (this.multiselectscheme)
              this.multiselectscheme.setMultiselect(value);
          }, 10);
        }
        else if (value.scheme_id == this.paymentForm.controls['scheme'].value) { }
        else if (value.schemeId == this.paymentForm.controls['scheme'].value) { }
        else {
          this.paymentForm.controls['is_discount'].setValue(false);
          this.discountchecked = false;
          this.visibility.discountFieldVisible = true;
          this.visibility.schemeVisible = false;
          this.visibility.disableField = true;
          this.paymentForm.controls['type'].setValue('direct');
          this.formService.blockMapping[1]['default_open'] = false;
        }

      }
      if (this.responses.schemeResponse == undefined) {
        // if(this.dataSet.orderedFrom == "Optical Order"){
        //   this.schemeApiSignature['args'] = "applicable_on:CUSTOM_SCHEME"
        // }
        this.baseService.getByDataSource(this.schemeApiSignature).subscribe(res => {
          if (res.errCode == 0 && res.count > 0 && this.responses.schemeResponse == undefined) {
            if (this.dataSet.transaction_type == 'Pharmacy Billing' || this.dataSet.transaction_type == 'OP Billing' || this.dataSet.transaction_type == 'Optical Billing' || this.dataSet.transaction_type == 'optical billing')
              this.formService.blockMapping[1]['default_open'] = true;
            this.responses.schemeResponse = res.resource;
            this.visibility.schemeVisible = true;
            this.visibility.disableField = false;
            this.amounts.is_discount = true;
            this.visibility.discountFieldVisible = false;
            this.paymentForm.controls['is_discount'].setValue(true);
            this.paymentForm.controls['scheme'].setValue(value.scheme_id ? value.scheme_id : value.schemeId);
            this.paymentForm.controls['scheme_name'].setValue(value.scheme_name ? value.scheme_name : value.schemeName);
          }
        });
      }

    } else if (value.discount == 0) {
      if (this.amounts && (!this.schm_rmvd || value.Payer_Changed)) {
        this.amounts.is_discount = false;
      }
      if (!this.schm_rmvd || value.Payer_Changed) {
        if (this.dataSet.transaction_type == 'OP Billing' && this.formService && this.formService.blockMapping && this.formService.blockMapping[1])
          this.formService.blockMapping[1]['default_open'] = false;
        this.visibility.disableField = true;
        this.paymentForm.controls['is_discount'].setValue(false);
        this.visibility.discountFieldVisible = true;
        this.visibility.schemeVisible = false;
        this.paymentForm.controls['discount_on'].reset('');
        this.paymentForm.controls['discount_type'].reset('amount');
        this.paymentForm.controls['discount_reason'].reset('');
        this.paymentForm.controls['discount_authorized_by'].reset('');
        this.paymentForm.controls['discount_authorized_by_id'].reset('');
        this.paymentForm.controls['discount'].reset(0);
        this.paymentForm.controls['scheme'].reset('');
        this.paymentForm.controls['type'].setValue('direct');
      }
      this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, typeToggled: true });
    }
    if (this.paymentForm.controls['discount_type'].value == "percentage" && this.paymentForm.controls['discount_on'].value == "bill" && value  && value.op_amount_value)
    {
      if(value.op_amount_value.discount_value > 0)
      this.paymentForm.controls['discount_value'].setValue(Number(value.op_amount_value.discount_value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    else
      this.paymentForm.controls['discount_value'].setValue(value.op_amount_value.discount_value)
    }
    else {
      if (value && value.op_amount_value) {
        if(value.op_amount_value.discount > 0)
        this.paymentForm.controls['discount_value'].setValue(Number(value.op_amount_value.discount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      else
      this.paymentForm.controls['discount_value'].setValue(value.op_amount_value.discount)
      }
    }
  }

  ngOnInit() {
    PaymentModeFlagsDecorator.loadConfig(this.baseService, () => PaymentModeFlagsDecorator.hideGridColumns(this.compositeArrayComponent));
    //this.amounts.is_discount=true;
    this.CompositeObj={
      "hideDelete":true,
    }
    if (this.itemresource && this.itemresource.question && this.itemresource.question.options)
      return
    this.itemresource = {
      "datasource": {
        "application": "facility-management",
        "resource": "delivery_charges_master",
        "query_id": "GET_PAGE",
        "args":"noCount:1",
        "filter": "status:active",
        "search_columns":"item_name",
      },
      controls: {
        item: {
          value: ""
        }
      },
      question: {
        defaultsetting: {
          "singleSelection": true,
          "checkBoxRequired": false,
          "closeDropDownOnSelection": true,
          "apliCall": false
        },
        getterKey: 'id',
        getterValue: 'item_name',
        req_keys: 'all',
        key: "item",
      },
      defaultsetting: {
        "singleSelection": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": true
      }
    }
    this.initializeAmt();
    this.getConfigOverridScheme();
    this.initializeVisibility();
    this.getDepositAmount();
    this.getconfigforbookorder();
    this.getconfigfordue();
   // this.getconfigforPaymentDecimal();
    if (this.paymentForm != undefined && this.paymentForm.controls != undefined && this.paymentForm.controls['is_discount'] != undefined && this.value_data != undefined && this.value_data.authorized_by_id != undefined) {
      this.opupdate();

      // this.schemeSetup(valueorder);
    }
    // this.schemedatasource = {
    //   "application": "facility-management",
    //   "resource": "scheme_detail",
    //   "query_id": "GET_SCHEME_DETAILS",  
    //   "args":"uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + this.dataSet.payerID

    // }
    // this.question = new SearchAndSelect({
    //   datasource: this.schemedatasource,
    //   defaultsetting: this.defaultsetting,
    //   getterKey: 'scheme_name',
    //   getterValue: 'scheme_name',
    //   options: true,
    //   type: "string",
    //   value: ""
    // }); 
    this.blockMapping = this.navVar;
    //sets block mapping in formservice
    if (window.location.href.includes("opbilling")) {
      this.navVar[3].show = false
    }

    this.formService.setBlockMapping(this.blockMapping);
    this.checkDuplicatePaymentMode();
  }

  overrideScheme(event, key) {
    if (event.target.checked) {
      this.amounts.override_scheme = true;
      this.visibility.disableDiscountValue = true;
    } else {
      this.amounts.override_scheme = false;
      this.visibility.disableDiscountValue = false;
    }
    this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, discount_type: this.paymentForm.controls['type'].value, 'scheme_name': this.paymentForm.controls['scheme_name'].value, 'schemeId': this.paymentForm.controls['scheme'].value, discount: this.paymentForm.controls['discount_value'].value, 'override_scheme': this.amounts.override_scheme });
  }

  addedresourceInfo() {
    console.log("this.patientInfo ", this.patientInfo);
    if (this.schemeresource && this.schemeresource.question && this.schemeresource.question.options)
      return
    this.schemeresource = {
      "datasource": {
        "application": "facility-management",
        "resource": "scheme_detail",
        "query_id": "GET_SCHEME_DETAILS",
        "args": "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + ((this.dataSet && this.dataSet.payer) ? this.dataSet.payer : '')
      },
      controls: {
        scheme: {
          value: ""
        }
      },
      question: {
        defaultsetting: {
          "singleSelection": true,
          "checkBoxRequired": false,
          "closeDropDownOnSelection": true,
          "apliCall": false
        },
        "req_keys": [
          "id",
          "scheme_name"
        ],
        getterKey: 'id',
        getterValue: 'scheme_name',
        key: "id"
      },
      defaultsetting: {
        "singleSelection": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": false
      }
    }
    // if(this.dataSet.orderedFrom == "Optical Order"){
    //   this.schemeresource.datasource['args'] += ",applicable_on:CUSTOM_SCHEME"
    // }
  }

  removeFirstZero(event, formControlName) {
    console.log(event.target.value);
    if (event.target.value.charAt(0) == 0) {
      let val = +event.target.value.replace(/^0+/, '');
      this.paymentForm.controls[formControlName].setValue(val);
    }
  }
  getDepositAmount() {
    try {
      // let args = '';
      // if (this.dataSet.preValue) {
      //   args = 'uhId:' + this.dataSet.preNo;
      // } else {
      //   args = 'uhId:' + this.patientInfo.uhId;
      // }
      var data = {
        args:
          "uhId:" + this.patientInfo.uhId + ",deposit_for:" + this.deposit_arg
      }
      if (!this.paymentForm.controls['deposit_amount'].value && !this.paymentForm.controls['deposit_wallet_id'].value) {
        this.baseService.get("GET_TOTAL_DEPOSIT_BY_UHID", data.args, "deposit_wallet", "payment").subscribe(res => {
          if (res.errCode == 0) {
            this.responses.depositApiResponse = res.resource;
            if (res.resource.length > 0) {
              this.paymentForm.controls['deposit_amount'].setValue(this.responses.depositApiResponse[0].available_amount);
              this.paymentForm.controls['deposit_wallet_id'].setValue(this.responses.depositApiResponse[0].id); //setting wallet id in case of using deposit
            }
          }
        })
      } else {
        //TODO
      }
    } catch (e) {
      console.error('Error while fetching deposit', e);
    }
  }
  getconfigfordue() {
    this.baseService.get('GET_CONFIG', 'module_code:billing,config_code:billing_804', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        console.log("res is....." + result)
        if (result.errCode == 0) {
          result = result.resource[0];
          this.due_config = result.config_value;
        }
      });
  }

  // getconfigforPaymentDecimal() {
  //   this.baseService.get('GET_CONFIG', 'module_code:facility-management,config_code:facility_mgnt_0013', 'facility_config_mapping', 'facility-management').subscribe(
  //     result => {
  //       console.log("res is....." + result)
  //       if (result.errCode == 0) {
  //         result = result.resource[0];
  //         if (result.config_value == "No") {
  //           this.configValueDecimal = "No";
  //         }
  //         if (result.config_value == "Yes") {
  //           this.configValueDecimal = "Yes";
  //         }


  //       }
  //     });
  // }

  onrecoverySelect(e) {
    this.rec_uhId = e.alldata.uhId;
    this.rec_employeeId = e.alldata.emp_no;
    this.rec_name = e.alldata.patient_name;

  }
  onrecoveryDeselect() {

  }
  emprecoveryselect(e) {
    let val;
    val = this.recoveryData.find(x => x.id == e);
    this.rec_uhId = val.uhId;
    this.rec_employeeId = val.emp_no;
    this.rec_name = val.patient_name;
  }
  opupdate() {
    this.visibility.disableField = false;
    this.paymentForm.controls['is_discount'].setValue(true);
    // this.paymentForm.controls['discount_authorized_by'].setValue(this.value_data.authorized_by_id != undefined ? this.value_data.authorized_by_id : "");
    this.paymentForm.controls['type'].setValue(this.value_data.type);
    this.paymentForm.controls['discount_on'].setValue(this.value_data.discount_on);
    this.paymentForm.controls['discount_type'].setValue(this.value_data.discount_type);
    this.paymentForm.controls['discount_reason'].setValue(this.value_data.discount_reason);
    if(this.value_data.discount_value > 0)
    this.paymentForm.controls['discount_value'].setValue(Number(this.value_data.discount_value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
  else
  this.paymentForm.controls['discount_value'].setValue(this.value_data.discount_value)
    this.paymentForm.controls['discount_authorized_by'].setValue(this.value_data.authorized_by_id);
    this.paymentForm.controls['discount_authorized_by_id'].setValue(this.value_data.authorized_by_id);
  }
  navigateToSection(elementId: string, blockId) {
    this.openScrollBox(elementId, blockId);
    this.activeKey = elementId;
    let el = document.getElementById(elementId);
    el.scrollIntoView();
    if (this.config.expanded_form) {
      window.scroll({ top: el.offsetTop, behavior: "smooth" });
    } else {
      // console.log("Top ",el.getBoundingClientRect().top);
      window.scroll({ top: el.getBoundingClientRect().top - 60, behavior: "smooth" });
    }
    //this.viewportScroller.scrollToAnchor(elementId);
    // window.location.hash = '';
    // window.location.hash = section;
  }
  openScrollBox(name, blockId) {
    this.activeKey = name;
    if (!this.config.expanded_form) {
      if (this.formService != undefined && this.formService.blockMapping != undefined) {
        this.formService.blockMapping.forEach((block, index) => {
          if (block['block_id'] == blockId || block['block_id'] == "bill_summary" || block['block_id'] == "payment_details") {
            this.formService.blockMapping[index]['default_open'] = true;
          } else {
            this.formService.blockMapping[index]['default_open'] = false;
          }
        })
      }
    }
  }
  openaccordianBox(name, blockId) {
    this.activeKey = name;
    if (!this.config.expanded_form) {
      if (this.formService != undefined && this.formService.blockMapping != undefined) {
        this.formService.blockMapping.forEach((block, index) => {
          if (block['block_id'] == blockId) {
            if (this.formService.blockMapping[index]['default_open'] == true)
              this.formService.blockMapping[index]['default_open'] = false;
            else
              this.formService.blockMapping[index]['default_open'] = true;
          }
        })
      }
    }
  }
  initializeVisibility() {
    this.visibility = {
      "discountFieldVisible": true,
      "schemeVisible": false,
      'showField': false,
      'disableFields': true,
      'enableUseDepositAmt': true,
      enableisadvance: true,
      'disableField': true,
      'disableDiscountValue': false,
      'validate': false,
      'noSubmit': false
    }
  }
  getconfigforbookorder() {
    this.baseService.get('GET_CONFIG', 'module_code:billing,config_code:032', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        if (result.errCode == 0) {
          result = result.resource[0];
          this.book_config = result.config_value;
          if ((this.config != undefined && this.config.application != undefined && this.config.application == 'optical'))
            this.navVar[3].show = true;
        }
      });
  }
  isadvance(event) {
    if (event.target['checked']) {
      let amt = Math.round(this.paymentForm.controls.net_receivable_amount.value);
      this.paymentForm.controls.is_default_amount.setValue(amt);
      // this.paymentForm.controls.net_receivable_amount.setValue(amt);
      this.visibility.enableisadvance = false;
      this.is_advance_checked = true;
    }
    else {
      this.paymentForm.controls.is_default_amount.setValue(0)
      this.paymentForm.controls.net_receivable_amount.setValue(Number(this.paymentForm.controls.net_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2))

      this.visibility.enableisadvance = true;
      this.is_advance_checked = false;
    }
  }
  initializeAmt() {
    this.amounts = {
      'sum': 0,
      'remainingDue': 0,
      'is_due': false,
      is_discount: false,
      'item_charges' : true,
      'discountValue': 0,
      'netAmount': 0,
      'paymentData': [],
      'paidAmount': [],
      'uniquePayment': [],
      'netPayableAmount': 0,
      'depositAmount': 0,
      'names': [],
      'localNet': 0,
      'localDeposit': 0,
      'localDue': 0,
      'removedAmount': 0,
      'timer': 30,
      'otp_required': false,
      'otp_verified': false,
      'otp_required_due': false,
      'otp_verified_due': false
    }
  }
  checkAdvance() {
    if (this.paymentForm.controls.is_default_amount.value > this.paymentForm.controls.net_amount.value) {
      this.alertService.error("Advance cannot be greater than net amount");
      this.paymentForm.controls.is_default_amount.setValue(this.paymentForm.controls.net_amount.value);
    }
    this.paymentForm.controls.net_receivable_amount.setValue(this.paymentForm.controls.net_amount.value - this.paymentForm.controls.is_default_amount.value)

  }

  toggleUseDeposit(event, name) {
    if (event.target['checked']) {
      this.navVar[6].default_open = true;
      this.visibility.enableUseDepositAmt = false;
      this.amounts.is_used_deposit = true;
      // if (this.paymentForm.controls['deposit_amount'].value!=undefined){
      //   if (this.paymentForm.controls['deposit_amount'].value > this.paymentForm.controls['net_receivable_amount'].value){
      //     this.paymentForm.controls['used_deposit_amount'].setValue(this.paymentForm.controls['net_receivable_amount'].value); 
      //   }
      //   else{
      //         this.paymentForm.controls['used_deposit_amount'].setValue(this.paymentForm.controls['deposit_amount'].value); 
      //         let sum =this.paymentForm.controls['net_receivable_amount'].value - this.paymentForm.controls['used_deposit_amount'].value
      //         this.paymentForm.controls['received_amount'].setValue(sum);
      //       }
      // }

      try {
        // let args = '';
        // if (this.dataSet.preValue) {
        //   args = 'uhId:' + this.dataSet.preNo;
        // } else {
        //   args = 'uhId:' + this.patientInfo.uhId;
        // }
        var data = {
          args:
            "uhId:" + this.patientInfo.uhId + ",deposit_for:" + this.deposit_arg
        }
        this.baseService.get("GET_TOTAL_DEPOSIT_BY_UHID", data.args, "deposit_wallet", "payment").subscribe(res => {
          if (res.errCode == 0) {
            this.responses.depositApiResponse = res.resource;
            if (res.resource.length > 0) {
              this.paymentForm.controls['deposit_amount'].setValue(this.responses.depositApiResponse[0].available_amount);
              this.paymentForm.controls['deposit_wallet_id'].setValue(this.responses.depositApiResponse[0].id); //setting wallet id in case of using deposit
              this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value);

              if (this.paymentForm.controls['deposit_amount'].value > 0) {
                this.resetPaymentDetail();
                if (this.paymentForm.controls['deposit_amount'].value != undefined) {
                  if (this.paymentForm.controls['deposit_amount'].value > this.paymentForm.controls['net_receivable_amount'].value || this.paymentForm.controls['deposit_amount'].value == this.paymentForm.controls['net_receivable_amount'].value) {
                    this.paymentForm.controls['used_deposit_amount'].setValue(this.paymentForm.controls['net_receivable_amount'].value);
                    this.paymentForm.controls['net_receivable_amount'].setValue(0);
                  }
                  else {
                    this.paymentForm.controls['used_deposit_amount'].setValue(this.paymentForm.controls['deposit_amount'].value);
                    let sum = this.paymentForm.controls['net_receivable_amount'].value - this.paymentForm.controls['used_deposit_amount'].value
                    this.paymentForm.controls['received_amount'].setValue(sum);
                    if(sum > 0)
                    this.paymentForm.controls['net_receivable_amount'].setValue(Number(sum).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
                  else
                  this.paymentForm.controls['net_receivable_amount'].setValue(sum);
                  }
                }

              }
            } else {
              this.visibility.enableUseDepositAmt = true;
              this.alertService.error("Amount is not deposited");
            }
          }
        })
      } catch (e) {
        console.error('Error while fetching deposit', e);
      }
    } else {
      let deposit = 0;
      this.visibility.enableUseDepositAmt = true;
      this.amounts.is_used_deposit = false;
      this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value);
      deposit = this.paymentForm.controls['used_deposit_amount'].value;
      this.amounts.netPayableAmount = Number(this.amounts.netPayableAmount) + Number(deposit);
      if(this.amounts.netPayableAmount > 0)
      this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    else
    this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
      this.paymentForm.controls['used_deposit_amount'].setValue(0);
      this.amounts.depositAmount = 0
      this.resetDueCheckbox();
      this.resetPaymentDetail();
      this.resetDiscountCheckbox();
    }
  }
  resetRealDiscountCheckbox() {
    this.paymentForm.controls['is_discount'].setValue(false);
    this.amounts.is_discount = false;
  }

  resetDiscountCheckbox() {
    this.paymentForm.controls['is_used_deposit'].setValue(false);
    this.amounts.is_used_deposit = false;
    this.visibility.showField = false;
  }
  resetDueCheckbox() {
    this.paymentForm.controls['is_due'].setValue(false);
    this.amounts.is_due = false;
    this.visibility.showField = false;
  }
  bindDropDownsFormExternalResources(discountType?) {
    if(this.paymentForm.controls['discount_on'].value == "service_item")
    this.wkflow_called = false;
    let discountedType = discountType ? discountType : this.paymentForm.controls['type'].value
    try {
      if (discountedType != 'scheme' && this.paymentForm.controls['discount'].value && this.paymentForm.controls['discount'].value != "0" && !this.wkflow_called) {
        let s_o_r;
        if (this.dataSet && this.dataSet.op_amount_value && (this.dataSet.op_amount_value.orderedFrom == "IPD Clinical Order" || this.dataSet.op_amount_value.orderedFrom == "IPD_CLINICAL_BILLING_AUTH_CLEARANCE")){
          s_o_r = (this.dataSet.transaction_type.split(" ")[0]).toUpperCase() + " CLINICAL SPLIT BILL DISCOUNT"
          this.wkflow_called = true;
        }
        else if (this.dataSet && this.dataSet.transaction_type == "Pharmacy Billing" && (this.dataSet.patient_type == "IP" || this.dataSet.op_amount_value.orderedFrom == "IPD_PHARMACY_SPLIT_BILL_AUTH_CLEARANCE")){
          s_o_r = "IPD PHARMACY SPLIT BILL DISCOUNT";
        }
        else{
          s_o_r = (this.dataSet.transaction_type.split(" ")[0]).toUpperCase() + " ORDER DISCOUNT"
        }
        this.discountApiSignature.args = "flow_master:discount,total_amount:" + this.paymentForm.controls['total_amount'].value + ",authorization_amount:" + this.paymentForm.controls['discount'].value + ",source_of_request:" + s_o_r
        this.baseService.getByDataSource(this.discountApiSignature).subscribe(res => {
          if (res.errCode == 0) {
            this.wkflow_called = true;
            this.responses.discountResponseData = res.resource;
          } else {
            this.responses.discountResponseData = [];
            this.alertService.error(res.message);
          }
        });
      }
      // if (!window.location.href.includes("ipbilling") && !window.location.href.includes("dcbilling") && !window.location.href.includes("erbilling")) {
        if (this.responses.discountTypeData == undefined) {
          this.baseService.getByDataSource(this.discountTypeApi).subscribe(res => {
            if (res.errCode == 0) {
              this.responses.discountTypeData = res.resource;
            }
          })
        }
      // }
      // if (!window.location.href.includes("ipbilling") && !window.location.href.includes("dcbilling") && !window.location.href.includes("erbilling")) {
        if (this.responses.reasonNameDiscountData == undefined) {
          this.baseService.getByDataSource(this.reasonTypeDiscountApi).subscribe(res => {
            if (res.errCode == 0) {
              this.responses.reasonNameDiscountData = res.resource;

            }
          })
        }
      // }
      // if (!window.location.href.includes("ipbilling") && !window.location.href.includes("dcbilling") && !window.location.href.includes("erbilling")) {
        if (this.responses.discType == undefined) {
          this.baseService.getByDataSource(this.discTypeApiSignature).subscribe(res => {
            if (res.errCode == 0) {
              this.responses.discType = res.resource;
            }
          });
        }
      // }
      // if (!window.location.href.includes("ipbilling") && !window.location.href.includes("dcbilling") && !window.location.href.includes("erbilling")) {
        if (this.responses.discOn == undefined) {
          this.baseService.getByDataSource(this.discOnApiSignature).subscribe(res => {
            if (res.errCode == 0) {
              this.responses.discOn = res.resource;
              if ((discountType != undefined || (this.paymentForm.controls['scheme'].value || this.paymentForm.controls['scheme_name'].value)) && !window.location.href.includes("approved_opticalorder") )
                this.paymentForm.controls['type'].setValue('scheme');
            }
          })
        }
      // }
    } catch (e) {
      console.error('Error while fetching discount properties', e);
    }
  }
  fetchDiscount(event, name) {
    this.paymentForm.controls['type'].setValue('direct');
    let tax = 0;
    let totalAmount = this.paymentForm.controls['total_amount'].value;
    if (this.paymentForm.controls['is_used_deposit'].value == true) {
      this.amounts.depositAmount = 0;
      this.paymentForm.controls['used_deposit_amount'].setValue(0);
    }
    this.paymentForm.patchValue({ discount: 0, discount_value: this.value_data != undefined && this.value_data.discount_value != undefined ? this.value_data.discount_value : 0, net_amount: totalAmount });
    //this.amounts.netPayableAmount = totalAmount + tax;
    if (event.target['checked']) {
      this.navVar[7].default_open = true;
      this.amounts.is_discount = true;
      this.discountchecked = true;
      //this.validateRemark(event, name);
      this.visibility.disableField = false;
      this.otp_visibility = false
      this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value });
      this.bindDropDownsFormExternalResources();
      this.resetDueCheckbox(); //resetting due amount field to fill new values
      this.resetPaymentDetail(); //resetting payment details field to fill new values
      this.resetDiscountCheckbox();
    } else {
      this.otp_visibility = false
      this.discountchecked = false;
      this.visibility.discountFieldVisible = true;
      this.visibility.schemeVisible = false;
      this.visibility.disableField = true;
      this.amounts.override_scheme = false;
      this.amounts.is_discount = false;
      if (this.override_config) {
        this.paymentForm.controls['override_scheme'].setValue(false);
        this.amounts.override_scheme = false;
      }
      this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, override_scheme: false });
      // RESETTING DISCOUNT ROW ELEMENTS VALUES
      this.paymentForm.controls['discount_on'].reset();
      this.paymentForm.controls['discount_type'].reset('amount');
      this.paymentForm.controls['discount_value'].reset(0);
      this.paymentForm.controls['discount_authorized_by'].reset();
      this.paymentForm.controls['discount_authorized_by_id'].reset();
      this.paymentForm.controls['discount'].reset(0);
      this.paymentForm.controls['scheme'].reset('');
      this.paymentForm.controls['discount_reason'].reset('');
      this.paymentForm.controls['used_deposit_amount'].setValue(0);
      this.paymentForm.controls['otp'].reset('');
      if (!this.paymentForm.controls['is_due'].value)
        this.showPaymentdeails = true;
      this.showDeposit = true;
      this.resetDueCheckbox(); //resetting due amount field to fill new values
      this.resetPaymentDetail(); //resetting payment details field to fill new values
    }
  }

  toggleIsDue(event, name) {
    if (this.configValueDecimal == "Yes" && this.changeDueAmountDecimal) {
      let dueAmountPaymentDecimal = this.paymentForm.controls['net_receivable_amount'].value;
      if(dueAmountPaymentDecimal > 0)
      this.paymentForm.controls['net_receivable_amount'].setValue(Number(dueAmountPaymentDecimal).toFixed(this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    else
    this.paymentForm.controls['net_receivable_amount'].setValue(dueAmountPaymentDecimal);
    }
    this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value);
    if (event.target['checked']) {
      this.navVar[6].default_open = true;
      this.visibility.showField = true;
      this.amounts.is_due = true;
      this.visible_is_due = false
      this.paymentForm.patchValue({ due_amount: this.amounts.netPayableAmount, net_receivable_amount: 0 });
      if (this.paymentForm.controls['due_amount'].value <= 0) {
        this.resetDueCheckbox();
        this.alertService.error("Due amount must be greater than zero");
      }
      this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value);
      console.log('due fetch api called');
      try {
        // this.baseService.getByDataSource(this.reasonTypeDiscountApi).subscribe(res => {
        //   if (res.errCode == 0) {
        //     this.responses.reasonNameData = res.resource;
        //   }
        // })
        this.getDueData();
        if (!window.location.href.includes("ipbilling") && !window.location.href.includes("dcbilling") && !window.location.href.includes("erbilling")) {
          if (this.responses.reasonNameDueData == undefined) {
            this.baseService.getByDataSource(this.reasonTypeDueApi).subscribe(res => {
              if (res.errCode == 0) {
                this.responses.reasonNameDueData = res.resource;
              }
            })
          }
        }
      } catch (e) {
        console.error('Error while fetching due', e);
      }
    } else {
      this.visibility.showField = false;
      this.amounts.is_due = false;
      this.amounts.remainingDue = Number(this.paymentForm.controls['due_amount'].value);
      this.paymentForm.patchValue({ due_amount: 0, net_receivable_amount: this.amounts.remainingDue });
      this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value);
      this.amounts.sum = 0;
      this.visible_is_due = false;
      this.showDeposit = true;
      if (!this.paymentForm.controls['is_discount'].value) {
        this.showPaymentdeails = true;
      }
    }
  }

  getDueData() {
    if (this.paymentForm.controls['due_amount'].value && this.paymentForm.controls['is_due'].value == true && this.paymentForm.controls['due_amount'].value != "0") {
      this.dueApiSignature.args = "flow_master:due,authorization_amount:" + this.paymentForm.controls['due_amount'].value + ",source_of_request:" + (this.dataSet.transaction_type.split(" ")[0]).toUpperCase() + " ORDER DUE"
      this.baseService.getByDataSource(this.dueApiSignature).subscribe(res => {
        if (res.errCode == 0) {
          this.responses.dueResponseData = res.resource;
        } else {
          this.responses.dueResponseData = []
          this.alertService.error(res.message);
        }
      })
    }
  }

  updatedDue() {
    this.paymentForm.controls['due_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
  }

  checkDeposit() {
    if (this.paymentForm.controls.used_deposit_amount.valid) {
      this.resetDueCheckbox(); //resetting due amount field to fill new values
      this.resetPaymentDetail(); //resetting payment details field to fill new values
      this.amounts.depositAmount = this.paymentForm.controls['used_deposit_amount'].value;
      let patientAmount = this.paymentForm.controls['final_amount'].value;
      if (this.paymentForm.controls['deposit_amount'].value < this.amounts.depositAmount) {
        this.alertService.error('Can Not Use Deposit More Than Deposit Amount. Used Deposit Resetting.', 'Invalid Use Deposit Error');
        this.paymentForm.controls['used_deposit_amount'].setValue(0);
        this.paymentForm.controls['net_receivable_amount'].setValue(Number(patientAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
        this.amounts.depositAmount = 0;
      } else if (this.amounts.depositAmount > patientAmount) {
        this.alertService.error('Can Not Use Deposit More Than Net Payable Amount. Used Deposit Resetting.', 'Invalid Use Deposit Error');
        this.paymentForm.controls['net_receivable_amount'].setValue(Number(patientAmount).toFixed(this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
        this.paymentForm.controls['used_deposit_amount'].setValue(0);
        this.amounts.depositAmount = 0;
      } else if (this.amounts.depositAmount == null || this.amounts.depositAmount == '' || this.amounts.depositAmount == undefined) {
        this.amounts.netPayableAmount = (patientAmount - this.paymentForm.controls['used_deposit_amount'].value);
        this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
        this.paymentForm.controls['used_deposit_amount'].setValue(0);
        this.amounts.depositAmount = 0;
        this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      } else if (this.amounts.depositAmount != 0) {
        this.amounts.netPayableAmount = (patientAmount - this.paymentForm.controls['used_deposit_amount'].value);
        this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
        this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
    }
  }

  validateDiscount(event: any) {
   // setTimeout(() => {
    this.schm_rmvd = false;
    this.scheme_idd = event.id;
    this.scheme_selected = true;
    if (this.paymentForm.controls['type'].value == 'scheme') {
      let scheme = this.paymentForm.controls['scheme'].value;
      if (scheme != undefined || scheme != '') {
        let schemeName = this.responses.schemeResponse.find(val => {
          return val.id == scheme;
        });
        this.paymentForm.controls['scheme_name'].setValue(schemeName ? schemeName.scheme_name : "");
      }
      this.amounts.override_scheme = false;
      <any>this.paymentForm.controls['override_scheme'].setValue(false);
      this.visibility.disableDiscountValue = false;
      if (event.isManual && this.appService.getApplication() == "optical"){
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, scheme_name: (event && event.alldata && event.alldata.scheme_name) ? event.alldata.scheme_name : "", schemeId: scheme, 'override_scheme': false });
      }
      if(this.appService.getApplication() != "optical"){
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, scheme_name: (event && event.alldata && event.alldata.scheme_name) ? event.alldata.scheme_name : "", schemeId: scheme, 'override_scheme': false });
      }
    } else if (this.paymentForm.controls['type'].value == 'direct') {
      if (this.paymentForm.controls['discount_on'].value == 'service_item') {
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, typeToggled: true });
      }
      if (this.paymentForm.controls['discount_on'].value == 'bill') {
        this.paymentForm.controls['discount_value'].setValue('');
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: 0, typeToggled: true });
      }
    }
    this.populateDisc();
    if (event == 'percentage' && this.paymentForm.controls['discount_value'].value > 100) {
      this.paymentForm.controls['discount_value'].markAsDirty();
    }
    else {
      this.paymentForm.controls['discount_value'].setValidators([Validators.required, Validators.maxLength(18), Validators.min(0)]);
    }
 // }, 500);

  }
  validateCharges(event: any){
    // this.visibility.showField = true;
    if (event && event.id != undefined && event.alldata.item_name != undefined) {
      this.deliveryCharges.emit({'facility_id': event.alldata.facility_id,'service_name': event.alldata.item_name,'service_code': event.alldata.item_code,'id': event.alldata.id,'discount_on': this.dataSet.discount_on,'discount': this.dataSet.discount_value});
    }
    // else if(event.text!=''){
    //   this.visibility.schemeVisible = true;
    // }
    // this.visibility.schemeVisible = true;
  }
  itemCharges(event: any){
    if (event && event.target && event.target['checked'] ) {
      this.navVar[7].default_open = true;
      this.visibility.disableFields = false;

    }
    else if (event.target['checked']==false) {
      this.visibility.disableFields = true;
      this.paymentForm.controls['item_name'].reset('');
      this.deliveryCharges.emit();
    }
  }
  validateChargesdeselect(event: any){
    if (event.id == undefined) {
      this.deliveryCharges.emit();
      // this.visibility.showField = true;
    }
  }
  validateDiscountdeselect(event: any) {
    this.schm_rmvd = true;
    this.scheme_idd = event.id;
    this.scheme_selected = true;
    if (this.paymentForm.controls['type'].value == 'scheme') {
      let scheme = this.paymentForm.controls['scheme'].value;
      if (scheme != undefined || scheme != '') {
        let schemeName = this.responses.schemeResponse.find(val => {
          return val.id == scheme;
        });
        this.paymentForm.controls['scheme_name'].setValue(schemeName ? schemeName.scheme_name : "");
      }
      this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, schemeId: scheme });
    } else if (this.paymentForm.controls['type'].value == 'direct') {
      if (this.paymentForm.controls['discount_on'].value == 'service_item') {
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, typeToggled: true });
      }
      if (this.paymentForm.controls['discount_on'].value == 'bill') {
        this.paymentForm.controls['discount_value'].setValue('');
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: 0, typeToggled: true });
      }
    }
    this.populateDisc();
    if (event == 'percentage' && this.paymentForm.controls['discount_value'].value > 100) {
      this.paymentForm.controls['discount_value'].markAsDirty();
    }
    else {
      this.paymentForm.controls['discount_value'].setValidators([Validators.required, Validators.maxLength(18), Validators.min(0)]);
    }
  }
  reasonMasterNameForDiscount(event) {
    if (this.responses && this.responses.reasonNameDiscountData) {
      let reasonDiscountData = this.responses.reasonNameDiscountData.find(val => {
        return val.name == event.target.value;
      });
      if (event)
        this.paymentForm.controls['discount_reason'].setValue(reasonDiscountData.name);
    }
  }

  reasonMasterNameForDue(event) {
    if (this.responses && this.responses.reasonNameDueData) {
      let reasonDueData = this.responses.reasonNameDueData.find(val => {
        return val.name == event.target.value;
      });
      if (event)
        this.paymentForm.controls['due_reason'].setValue(reasonDueData.name);
    }
  }


  schemeClicked(event) {
    let data = {
      args: "id:" + this.scheme_idd,
      resource: 'scheme_detail_bill',
      action: 'view',
      query_id: 'GET_BY_ID',
      application: 'facility-management'

    }

    this.baseService.modalService.dialogService.open(BillingpopupComponent, { size: DialogModalSize.Lg, data }).afterClosed.subscribe(data => { }, err => { })
  }

  toggleFieldsOnScheme(event) {
    if(this.paymentForm.controls['scheme'].value && this.dataSet.transaction_type == "optical billing")
    this.paymentForm.controls['scheme'].setValue("")
    this.schm_rmvd = true;
    console.log("inside again 1")
    this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value, toggled: true });
    let tax = 0;
    let totalAmount = this.paymentForm.controls['total_amount'].value;
    this.paymentForm.patchValue({ discount: 0, discount_value: 0, net_amount: totalAmount, net_receivable_amount: this.paymentForm.controls['final_amount'].value })
    this.visibility.disableDiscountValue = false;
    this.paymentForm.controls['used_deposit_amount'].setValue(0);
    this.paymentForm.controls['due_amount'].setValue(Number(this.paymentForm.controls['final_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    if (event.target.value == 'scheme') {
      this.addedresourceInfo()
      this.visibility.discountFieldVisible = false;
      if (this.dataSet.transaction_type == "OP Billing" || this.dataSet.transaction_type == "Optical Billing") {
        this.schemeresource = {
          "datasource": {
            "application": "facility-management",
            "resource": "scheme_detail",
            "query_id": "GET_SCHEME_DETAILS",
            "args": "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + ((this.dataSet && this.dataSet.payer) ? this.dataSet.payer : '')
          },
          question: {
            defaultsetting: {
              "singleSelection": true,
              "checkBoxRequired": false,
              "closeDropDownOnSelection": true,
              "apliCall": false
            },
            "req_keys": [
              "id",
              "scheme_name"
            ],
            getterKey: 'id',
            getterValue: 'scheme_name',
            key: "id"
          },
          controls: {
            due_reason: {
              value: ""
            }
          },
          defaultsetting: {
            "singleSelection": true,
            "checkBoxRequired": false,
            "closeDropDownOnSelection": true,
            "apliCall": false
          }
        }
      }
      this.visibility.schemeVisible = true;
      if (!this.paymentForm.controls['scheme'].value || (this.dataSet.scheme_id == "" && !this.dataSet.scheme_discount_applicable))
        this.paymentForm.controls['scheme'].setValue('')
      try {
        console.log("Data ", this.dataSet);
        this.schemeApiSignature['args'] = "";
        if (this.patientInfo != undefined && this.patientInfo.uhId != undefined) {
          if (this.dataSet && this.dataSet.transaction_type && this.dataSet.transaction_type == "Pharmacy Billing") {
            this.schemeApiSignature['args'] = "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + this.dataSet.payerID;
          } else if (this.dataSet && this.dataSet.transaction_type && this.dataSet.transaction_type == "OP Billing") {
            this.schemeApiSignature['args'] = "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + this.dataSet.payer;
            if (this.appService.getUniversalConfig('multi_care_type')) {
              this.schemeApiSignature['args'] += ",care_type:" + this.appService.getDynamicFunctions("getCurrentCareType")
            }
          } else {
            this.schemeApiSignature['args'] = "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender;
          }

        }
        // if(this.dataSet.orderedFrom == "Optical Order"){
        //   this.schemeApiSignature['args'] += ",applicable_on:CUSTOM_SCHEME"
        // }
        this.baseService.getByDataSource(this.schemeApiSignature).subscribe(res => {
          console.log('scheme api data ==>>', res);
          if (res.errCode == 0 && res.count > 0) {
            this.responses.schemeResponse = res.resource;
          }
        })
      } catch (e) {
        console.error('Error => ', e);
      }
    } else {
      if (event.target.value == 'service_item') {
        this.visibility.disableDiscountValue = true;
      }
      this.visibility.discountFieldVisible = true;
      this.visibility.schemeVisible = false;
    }
  }


  dueAuthorizeName(event) {
    this.dueName = this.responses.dueResponseData.find(val => {
      return val.userId == event.target.value;
    });
    if (this.dueName != undefined)
      this.paymentForm.controls['due_authorised_by_name'].setValue(this.dueName.userName);
    if (this.dueName.workflow_stage == "otp_based")
      this.authorizationAction('due', this.paymentForm.controls['due_authorised_by_id'].value, this.paymentForm.controls['due_authorised_by_name'].value, this.dueName);
    if(this.dueName.workflow_stage == "single_stage" && this.paymentForm.controls['is_due'].value==true && this.paymentForm.controls['used_deposit_amount'].value!=0){
      this.resetDepositCheckbox();
    }
    if (this.dueName.workflow_stage == "single_stage" || this.dueName.workflow_stage == "multi_stage") {
      this.showDeposit = false; this.showPaymentdeails = false;
      if (this.paymentForm.controls['payment_detail'].value && this.paymentForm.controls['payment_detail'].value.length != 0) {
        this.resetDueCheckbox(); this.resetDiscountCheckbox(); this.resetPaymentDetail();
        // this.resetRealDiscountCheckbox();
        // this.showPaymentdeails = true;
      }
    }
  }

  resetDepositCheckbox() {
    this.paymentForm.controls['due_amount'].setValue(Number(this.paymentForm.controls['due_amount'].value+this.paymentForm.controls['used_deposit_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    this.paymentForm.controls['used_deposit_amount'].setValue(0);
  }
  
  checkremarksmandatory() {
    if ((this.dueName && (this.dueName.workflow_stage == "single_stage" || this.dueName.workflow_stage == "multi_stage")) || (this.discountData && (this.discountData.workflow_stage == "single_stage" || this.discountData.workflow_stage == "multi_stage"))) {
      return true
    } else {
      return false
    }
  }

  submit() {
    console.log('userdata ==>>', this.paymentForm.getRawValue());
  }

  checkDuplicatePaymentMode() {
    this.baseService.get('GET_CONFIG', 'module_code:payment,config_code:payment_100', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        if (result.errCode == 0 && result.resource.length > 0) {
          this.duplicatePaymentConfigResult = result.resource[0].config_value
        }
      });
  }
  OnPaymentAdd(event) {
    PaymentModeFlagsDecorator.hideGridColumns(this.compositeArrayComponent);
    if (event.items != undefined && event.items.length > 0) {
      if (this.duplicatePaymentConfigResult && this.duplicatePaymentConfigResult == 'no') {
        for (let i = 0; i < event.items.length - 1; i++) {
          let element = event.items[i];
          if (element['payment_mode_code'] == event.items[event.items.length - 1].payment_mode_code) {
            this.compositeArrayComponent.removeRow(event.items.length - 1);
            this.alertService.error('Same payment mode can not accept multiple times');
            return;
          }
        };
      }
      else if (this.duplicatePaymentConfigResult && this.duplicatePaymentConfigResult == 'yes') {
        let i = 0;
        const transactionMap = new Map();
        if (event.items && event.items.length > 0)
          for (const element of event.items) {
            if (element.payment_mode_code == 'Cash') {
              i = i + 1
              this.adding = i
            }
            else {
              const txnNo = (element.transaction_no || element.request_transaction_no || '').toString().trim();
              const bankId = (element.bank_id || element.bank_code || '').toString().trim();
              const key = `${txnNo}_${bankId}`;
              if (txnNo && bankId && transactionMap.has(key)) {
                this.compositeArrayComponent.removeRow(event.items.length - 1);
                this.alertService.error('Duplicate bank name and transaction number combinations are not allowed.');
                return;
              }
              transactionMap.set(key, true);
            }
          }
        if (this.adding && this.adding > 1) {
          this.compositeArrayComponent.removeRow(event.items.length - 1);
          this.alertService.error('Same payment mode can not accept multiple times');
          return;
        }
      }
      if (event.items[event.items.length - 1].payment_mode_code == "pos" && event.items[event.items.length - 1].integrated_pos_machine == "integrated_pos" && event.action != 'delete') {
        let deviceID = this.appService.readCookie('device_id');
        let resource = {
          deviceId: deviceID,
          amount: event.items[event.items.length - 1].received_amount,
          uhId: this.patientInfo.uhId
        }
        this.baseService.action(resource, 'POS_PAYMENT_REQUEST', 'payment-gateway', 'ui_gateway_response').subscribe(response => {
          console.log("Resopnse from payment gateway", response)
          if (response && response.resource && response.resource[0] && response.resource[0].extra_data) {
            this.pos_transaction_id = response.resource[0].extra_data.gateway_transactionId
            this.paymentForm.controls['payment_detail'].value[this.paymentForm.controls['payment_detail'].value.length - 1].transaction_no = response.resource[0].extra_data.gateway_transactionId
            this.paymentForm.controls['payment_detail'].value[this.paymentForm.controls['payment_detail'].value.length - 1].kx_transaction_no = response.resource[0].extra_data.kx_transactionId
          }
        });
      }
    }
    this.amounts.sum = 0;
    if (this.configValueDecimal == "Yes") {
      if (this.paymentForm.controls['net_receivable_amount'].value) {
        this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2);
      }
    } else {
      this.amounts.netPayableAmount = this.paymentForm.controls['net_receivable_amount'].value;
    }
    if (this.paymentForm.controls['net_receivable_amount'].value < 0)
      this.paymentForm.controls['net_receivable_amount'].setValue(0)
    this.amounts.paidAmount = [];
    if (event.type !== false && event.action != 'delete') {
      if (event.items != undefined && event.items.length > 0) {
        this.addedAmount = event.items[event.items.length - 1].received_amount;
        for (let i = 0; i < event.items.length; i++) {
          let element = event.items[i];
          if (element['received_amount'] == 0) {
            this.compositeArrayComponent.removeRow(event.items.length - 1);
            this.alertService.error('Amount added must be greater than zero');
            return;
          }
          this.amounts.sum += Number(element.amount);
        }
      }
      this.amounts.paymentData = this.paymentForm.controls['payment_detail'].value;
      if (this.amounts.paymentData != null) {
        for (let entry of this.amounts.paymentData)
          this.amounts.paidAmount.push(entry.amount);

        if (event.action == 'edit') {
          let patientAmount = this.paymentForm.controls['final_amount'].value;
          if (this.amounts.sum > patientAmount) {
            this.compositeArrayComponent.removeRow(this.amounts.paymentData.length - 1);
            this.alertService.error('Amount Paid More Than Net Payable Amount', 'Excess Payment Added');
          } else {
            if (this.amounts.is_due) {
              let patientAmount = this.paymentForm.controls['final_amount'].value - this.paymentForm.controls['authorised_amount'].value;
              this.paymentForm.controls['due_amount'].setValue(Number(this.paymentForm.controls['final_amount'].value - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['net_receivable_payer_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));

              if (this.configValueDecimal == "Yes") {
                let dueAmountForOP = this.paymentForm.controls['due_amount'].value;


                dueAmountForOP = Math.abs(dueAmountForOP.toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
                this.paymentForm.controls['due_amount'].setValue(Number(dueAmountForOP).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
                this.amounts.due_amount = this.paymentForm.controls['due_amount'].value;
              } else {
                this.amounts.due_amount = this.paymentForm.controls['due_amount'].value;
              }

              if (this.amounts.due_amount <= 0) {
                this.resetDueCheckbox();
              }
              if (this.configValueDecimal == "Yes") {
                let subtractedAmountForDecimalConfig: any;
                subtractedAmountForDecimalConfig = patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value;
                this.amounts.netPayableAmount = subtractedAmountForDecimalConfig.toFixed(2) - this.paymentForm.controls['due_amount'].value;
                this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
                if(this.amounts.netPayableAmount > 0)
                this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
              else
              this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
              } else {
                this.amounts.netPayableAmount = (patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['due_amount'].value);
                this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
                if(this.amounts.netPayableAmount > 0)
                this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
              else
              this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
              }

            } else {
              this.paymentForm.controls['due_amount'].setValue(0);
              this.amounts.netPayableAmount = (patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['due_amount'].value);
              this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
              if(this.amounts.netPayableAmount > 0)
              this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
            else
            this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
            }
          }
        } else {
          if (this.amounts.is_due) {
            this.amounts.due_amount = this.paymentForm.controls['due_amount'].value;
            if (this.paymentForm.controls['due_amount'].value >= this.amounts.paidAmount[this.amounts.paidAmount.length - 1]) {
              let patientAmount = this.paymentForm.controls['final_amount'].value;
              this.paymentForm.controls['due_amount'].setValue(Number(this.paymentForm.controls['final_amount'].value - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
              if (this.amounts.due_amount <= 0) {
                this.resetDueCheckbox();
              }
              this.amounts.netPayableAmount = (patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['due_amount'].value);
              this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
              if(this.amounts.netPayableAmount > 0)
              this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
            else
            this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
            }
            else {
              if (this.amounts.due_amount <= this.amounts.paidAmount[this.amounts.paidAmount.length - 1]) {
                this.compositeArrayComponent.removeRow(this.amounts.paymentData.length - 1);
                this.alertService.error('Amount Paid More Than Net Payable Amount', 'Excess Payment Added');
              }
              this.paymentForm.controls['net_receivable_amount'].setValue(0);
            }
          } else {
            this.paymentForm.controls['due_amount'].setValue(0);
            if (Number(this.amounts.netPayableAmount) >= Number(this.amounts.paidAmount[this.amounts.paidAmount.length - 1])) {
              let patientAmount = this.paymentForm.controls['final_amount'].value;
              this.amounts.netPayableAmount = this.is_advance_checked ? this.paymentForm.controls.net_receivable_amount.value - this.addedAmount : (patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['due_amount'].value);
              this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
              if (this.configValueDecimal == "Yes") {
                let netPayableAmountForDecimal = Math.abs(this.amounts.netPayableAmount);
                this.amounts.netPayableAmount = netPayableAmountForDecimal.toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2);
                this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
              }
              if(this.amounts.netPayableAmount > 0)
              this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
              else
              this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
            }
            else {
              // if (this.amounts.paymentData.length > 0) {
              //   this.compositeArrayComponent.removeRow(this.amounts.paymentData.length - 1);
              //   this.alertService.error('Amount Paid More Than Net Payable Amount', 'Excess Payment Added');
              // }
            }
          }
        }
      }
    }
    this.getDueData()
  }

  removeDuplicatePaymentDetails(array) {
    return array.filter((value, index) => array.indexOf(value) === index);
  }

  resetPaymentDetail() {
    this.paymentForm.controls['payment_detail'].reset();
    let sum = 0;
    if (this.paymentForm.controls['payment_detail'].value != null) {
      this.paymentForm.controls['payment_detail'].value.forEach(element => {
        sum += element.received_amount;
      });
    }
    this.paymentForm.controls['net_receivable_amount'].setValue(this.paymentForm.controls['final_amount'].value - sum);
    this.amounts.sum = 0;
    this.updatedDue();
  }

  populateDisc(flag?) {
    this.wkflow_called = false;
    if (this.appService.getApplication() == "optical" && this.paymentForm.controls['type'].value == 'scheme' && this.dataSet && this.dataSet.op_amount_value) {
      if(this.dataSet.op_amount_value.discount > 0)
      this.paymentForm.controls['discount_value'].setValue(Number(this.dataSet.op_amount_value.discount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    else
    this.paymentForm.controls['discount_value'].setValue(this.dataSet.op_amount_value.discount);
    }
    this.paymentForm.controls['used_deposit_amount'].setValue(0);
    if (flag != undefined) { this.paymentForm.controls['discount_authorized_by'].setValue(""); this.paymentForm.controls['discount_authorized_by_id'].setValue(""); }
    this.resetDueCheckbox(); //resetting due amount field to fill new values
    // this.resetPaymentDetail(); //resetting payment details field to fill new values
    console.log("netPayable populateDisc - ", this.amounts.netPayableAmount);
    if (this.paymentForm.controls['discount_value'].value == '' && this.paymentForm.controls['type'].value != 'scheme') {
      this.paymentForm.controls['discount_value'].setValue(0);
      this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: 0 });
    }
    let type = this.paymentForm.controls['discount_type'].value;
    let totalAmt = Number(this.paymentForm.controls['total_amount'].value);
    let netAmt = Number(this.paymentForm.controls['final_amount'].value);
    this.amounts.discountValue = this.paymentForm.controls['discount_value'].value;
    let discOnAmt = this.amounts.discountValue;
    let tax = 0;
    if (this.amounts.discountValue > 0) {
      if(type === ""){
        this.alertService.error('Please fill discount type first');
        this.paymentForm.controls['is_discount'].setValue(false);
        this.amounts.is_discount = false;
      }
      if (type == 'percentage') {
        if (this.amounts.discountValue <= 100) {
          let disc = (totalAmt * this.amounts.discountValue) / 100;
          this.paymentForm.patchValue({ discount: disc, net_amount: totalAmt - disc, net_receivable_amount: totalAmt - disc + tax });
          this.amounts.netPayableAmount = totalAmt - discOnAmt + tax;
          this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: discOnAmt });
          this.bindDropDownsFormExternalResources(); //line for checking again discount
        }
        else {
          this.alertService.error('Invalid Discount entered. Resetting', 'Reset')
          this.paymentForm.patchValue({ discount_value: 0, discount: 0, net_amount: totalAmt, net_receivable_amount: this.paymentForm.controls['final_amount'].value });
        }
      } else {
        if (this.amounts.discountValue <= totalAmt) {
          if (type == 'amount') {
            this.paymentForm.patchValue({ discount: discOnAmt, net_amount: totalAmt - discOnAmt, net_receivable_amount: totalAmt - discOnAmt + tax });
            this.paymentForm.controls['discount'].setValue(this.amounts.discountValue);
          } else {
            this.paymentForm.patchValue({ discount: discOnAmt, net_amount: totalAmt - discOnAmt, net_receivable_amount: totalAmt - discOnAmt + tax });
          }
          this.amounts.netPayableAmount = totalAmt - discOnAmt + tax;
          this.bindDropDownsFormExternalResources(); //line for checking again discount
          // Now working code is
          if (this.paymentForm.controls['type'].value == 'scheme' && this.paymentForm.controls['scheme'].value) {
            this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, scheme_name: this.paymentForm.controls['scheme_name'].value, schemeId: this.paymentForm.controls['scheme'].value, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value });
          } else {
            this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value });
          }

          //Earlier this was written 
          // this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value });
        }
        else if (this.paymentForm.controls['type'].value == 'direct') {
          this.alertService.error('Invalid Discount entered. Resetting', 'Reset')
          this.paymentForm.patchValue({ discount_value: 0, discount: 0, net_amount: totalAmt, net_receivable_amount: this.paymentForm.controls['final_amount'].value });
        }
      }
    }
    else
      this.paymentForm.patchValue({ discount: (this.paymentForm.controls['type'].value == 'scheme'?this.paymentForm.controls.discount.value :0), net_amount: totalAmt, net_receivable_amount: this.paymentForm.controls['final_amount'].value });
  }

  discountauthorisedName(event) {
    this.time_for_otp_reset = true
    this.discountData = this.responses.discountResponseData.find(val => {
      return val.userId == event.target.value;
    });
    this.paymentForm.controls['discount_authorized_by_name'].setValue(this.discountData.userName);
    this.paymentForm.controls['discount_authorized_by_id'].setValue(this.discountData.userId);
    if (this.paymentForm.controls.type.value == 'direct' && this.discountData.workflow_stage == "otp_based")
      this.authorizationAction('discount', this.paymentForm.controls['discount_authorized_by'].value, this.paymentForm.controls['discount_authorized_by_name'].value, this.discountData);
    if (this.discountData.workflow_stage == "single_stage" || this.discountData.workflow_stage == "multi_stage") {
      this.showDeposit = false; this.showPaymentdeails = false;
      if (this.paymentForm.controls['payment_detail'].value && this.paymentForm.controls['payment_detail'].value.length != 0) {
        this.resetDueCheckbox(); this.resetDiscountCheckbox(); this.resetPaymentDetail();
        // this.resetRealDiscountCheckbox();
        // this.showPaymentdeails = true;
      }
    }
    if (this.discountData.workflow_stage == "notify_only")
      this.visibility.disableField = true;
    if (this.paymentForm.controls.discount_on.value == 'service_item' && this.discountData.workflow_stage == "notify_only") {
      this.authoriseDetail.emit({ 'discount_on': this.paymentForm.controls.discount_on.value });
    }
  }
  authorizationAction(type, id, name, authorize_value?) {
    if (type == 'discount')
      this.amounts.otp_verified = false;
    else if (type == 'due')
      this.amounts.otp_verified_due = false;
    this.loader.showSpinner();
    if (type == 'discount' && !authorize_value)
      authorize_value = this.discountData
    if (type == 'due' && !authorize_value)
      authorize_value = this.dueName
    let Arr = [];
    Arr.push({ "id": authorize_value.id, "user_role_name": authorize_value.user_role_name, "userName": authorize_value.userName, "userId": authorize_value.userId, "login_id": authorize_value.login_id, "contact_no": authorize_value.contact_no, "email_address": authorize_value.email_address, "active_period": authorize_value.active_period })
    // // let result = {
    //   "authorized_by_id": id,
    //   "authorized_by": name,
    //   "uhId": this.patientInfo.uhId,
    //   "discount_type": this.paymentForm.controls['discount_on'].value,
    //   "transaction_type": this.dataSet['transaction_type'],
    //   "authorized_type": type,
    //   "patient_type": this.dataSet.patient_type,
    //   "total_amount": this.paymentForm.controls['total_amount'].value,
    //   "final_amount": this.paymentForm.controls['net_receivable_amount'].value,
    // }
    if (type == 'discount') {
      authorize_value["flow_amount"] = this.paymentForm.controls['discount'].value;
      authorize_value['op_amount'] = this.dataSet.op_amount_value;
      authorize_value['authority_checkpoints'] = Arr
    } else if (type == 'due') {
      authorize_value["flow_amount"] = this.paymentForm.controls['due_amount'].value;
      authorize_value['op_amount'] = this.dataSet.op_amount_value;
      authorize_value['authority_checkpoints'] = Arr
    }
    if (this.dataSet && this.dataSet.op_amount_value && (this.dataSet.op_amount_value.orderedFrom == "IPD Clinical Order" || this.dataSet.op_amount_value.orderedFrom == "IPD_CLINICAL_BILLING_AUTH_CLEARANCE")){
      let patientadmissionid = sessionStorage.getItem('admissionidip');
      authorize_value["admissionId"] = patientadmissionid;
      authorize_value["uhId"] = authorize_value.op_amount.uhId
      let billing_discount_data = {
        "authorized_by_id" : this.discountData.userId,
        "authorized_by": this.discountData.userName,
        "uhId" :  authorize_value.uhId,
        "admissionId" : authorize_value.admissionId,
        "transaction_type" : "IP Billing",
        "discount_type" : authorize_value.op_amount.discount_on,
        "authorized_type" : "discount",
        "patient_type" : authorize_value.op_amount.patient_type,
        "total_amount" : authorize_value.op_amount.total_amount,
        "final_amount" : authorize_value.op_amount.final_payable,
        "authorized_amount" : authorize_value.op_amount.discount_value,
        "authority_checkpoints" : authorize_value.authority_checkpoints,
        "flow_master" : authorize_value.flow_master,
        "source_of_request" : authorize_value.source_of_request,
        "workflow_stage" : authorize_value.workflow_stage,
        "flow_amount" : authorize_value.flow_amount,
      }
      authorize_value['billing_discount'] = billing_discount_data
    }
    if (id != "" && ((this.dueName && this.dueName.workflow_stage == "otp_based") || (this.discountData && this.discountData.workflow_stage == "otp_based")) && ((this.discountData && this.discountData.otp_required) || (this.dueName && this.dueName.otp_required))) {
      this.baseService.action(authorize_value, 'ADD_AUTHORITY_CLEARANCE', 'billing', 'authority_clearance').subscribe(
        (data: any) => {
          console.log("Response from ADD_DISCOUNT_AUTHORITY ", data);
          if (data.errCode == 0 && data.resource.length > 0) {
            if (type == 'discount') {
              this.otp_id_discount = data.resource[0].id
              this.amounts.otp_required = data.resource[0].isOtp_required;
              if (data.resource[0].isOtp_required != true) {
                this.visibility.disableField = true;
              }
              else {
                this.otp_visibility = true
              }
              if (this.paymentForm.controls.discount_on.value == 'service_item') {
                this.authoriseDetail.emit({ 'discount_on': this.paymentForm.controls.discount_on.value });
              }
              this.paymentForm.controls['otp'].reset()
            } else if (type == 'due') {
              this.otp_id_due = data.resource[0].id
              this.amounts.otp_required_due = data.resource[0].isOtp_required;
              if (data.resource[0].isOtp_required != true) {
                this.visible_is_due = false
              }
              else {
                this.visible_is_due = true
              }
              this.paymentForm.controls['otp_due'].reset()
            }
            if (this.amounts.otp_required || this.amounts.otp_required_due) {
              clearTimeout(this.otptimeout);
              this.time_for_otp_reset = false
              this.countdown(30);
            }
            else {
              this.time_for_otp_reset = true
            }
          } else {
            this.time_for_otp_reset = true
            if (type == 'discount') {
              this.paymentForm.controls['discount_authorized_by'].reset('');
              this.paymentForm.controls['discount_authorized_by_id'].reset('');
              this.paymentForm.controls['discount_value'].reset(0);
              this.visibility.disableField = false;
            }
            if (type == 'due') {
              this.paymentForm.controls['due_authorised_by_id'].reset('');
            }
            this.otp_visibility = false
            // this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: 0, toggled: true });
            this.alertService.error(data.message);
          }
          this.loader.hideSpinner();
        });
    }
    else {
      this.loader.hideSpinner();
      this.amounts.otp_required = false;
      this.otp_visibility = false
      if (type == "due")
        this.amounts.otp_required_due = false
    }
  }
  countdown(x) {
    if (this.time_for_otp_reset) {
      return
    }
    if (x === 0) {
      this.amounts.timer = x;
      return;
    }
    this.otptimeout = setTimeout(() => { this.amounts.timer = x; this.countdown(--x); }, 1000)
    return this.otptimeout;
  }

  checkOTP(event, type, id, name) {
    console.log("Event is ", event.target.value);
    this.loader.showSpinner();
    let result = {
      'otp': event.target.value
    }
    if (type == 'discount')
      result['id'] = this.otp_id_discount
    if (type == 'due')
      result['id'] = this.otp_id_due
    this.baseService.action(result, 'VERIFY_OTP', 'billing', 'authority_clearance').subscribe(
      (data: any) => {
        console.log("Response from VERIFY_OTP ", data);
        if (data.errCode == 0 && data.resource.length > 0) {
          if (type == 'discount')
            this.amounts.otp_verified = true;
          else if (type == 'due')
            this.amounts.otp_verified_due = true;
          this.alertService.success("OTP Verified")
          this.visibility.disableField = true
        } else {
          this.visibility.disableField = false
          this.paymentForm.controls['otp'].setValue('');
          if (type == 'discount')
            this.amounts.otp_verified = false;
          else if (type == 'due') {
            this.paymentForm.controls['otp_due'].setValue('');
            this.amounts.otp_verified_due = false;
          }
          this.alertService.error(data.message);
        }
        this.loader.hideSpinner();
      });
  }

  createBill(event) {
    if (this.paymentForm && this.paymentForm.controls && this.paymentForm.controls['used_deposit_amount'] && this.paymentForm.controls['used_deposit_amount'].value > 0 && this.paymentForm.controls['used_deposit_amount'].status == "INVALID")
    {
    this.alertService.error("Please enter valid Used Deposit Amount.");
    return;
    }
    if (this.dataSet && this.dataSet.transaction_type != 'OP Billing') {
      this.createDisable = true;
      if(this.dataSet.transaction_type == 'Pharmacy Billing') {
        this.createDisable = false;
      }
      else {
        setTimeout(() => {
          this.createDisable = false;
        }, 3000)
      }
    }
    else
      this.createDisable = true;
    if (this.paymentForm.controls['is_discount'].value) {
      if (this.discount_remark_mandatory_config_value) {
        if (this.paymentForm.controls['discount_reason'].value == "" || this.paymentForm.controls['discount_reason'].value == undefined) {
          this.alertService.error("Please select Discount Reason");
          this.createDisable = false;
          return;
        }
      }
    }

    if (this.paymentForm.controls['is_due'].value) {
      if (this.due_remark_mandatory_config_value) {
        if (this.paymentForm.controls['due_reason'].value == "" || this.paymentForm.controls['due_reason'].value == undefined) {
          this.alertService.error("Please select Due Reason");
          this.createDisable = false;
          return;
        }
      }
    }
    if ((this.amounts.otp_required && !this.amounts.otp_verified && (this.visible_is_due || this.otp_visibility)) || ((this.visible_is_due || this.otp_visibility) && this.amounts.otp_required_due && !this.amounts.otp_verified_due)) {
      this.alertService.error("Please verify OTP and proceed");
      this.createDisable = false;
    } else {
      if (this.amounts.is_due) {
        if (this.paymentForm.controls['due_amount'].value <= 0) {
          this.resetDueCheckbox();
        }
      }
      if (this.paymentForm.controls['is_used_deposit'].value && this.paymentForm.controls['used_deposit_amount'].value <= 0) {
        this.paymentForm.controls['is_used_deposit'].setValue(false);
      }
      let sum = 0;
      if (this.paymentForm.controls['payment_detail'].value != null) {
        this.paymentForm.controls['payment_detail'].value.forEach(element => {
          if (this.configValueDecimal == "Yes") {
            let receivedAmount = Number(element.received_amount);
            sum += receivedAmount;
          } else {
            sum += element.received_amount;
          }
        });
      }
      this.paymentForm.controls['received_amount'].setValue(sum);
      if (event == 'cancel') {
        this.createBillButton.emit({ "button": event });
      } else if (this.paymentForm.valid) {
        if (this.paymentForm.controls['noOfInstallment'].value == 0) {
          this.navVar[5].default_open = true;
          this.alertService.error("No. of installment can not be 0");
          this.createDisable = false;
          return;
        } let Arr = []; let emtArr = [];
        let obj = { "payment": this.paymentForm.getRawValue(), "button": event, "recovery_uhId": this.rec_uhId, "recovery_empId": this.rec_employeeId, "rec_name": this.rec_name, "isrecovery": (this.paymentForm.controls['noOfInstallment'].value && this.paymentForm.controls['recovery'].value) ? true : false, discountData: this.discountData, dueData: this.dueName, hasTotalAmount: this.paymentForm.controls.total_amount.value }

        if (this.discountData && this.discountData.workflow_stage == "single_stage") {
          Arr.push(this.discountData)
          obj['discountData'] = Arr
        }
        if (this.dueName && this.dueName.workflow_stage == "single_stage") {
          emtArr.push(this.dueName)
          obj['dueData'] = emtArr;
        }
        if (this.discountData && this.discountData.workflow_stage == "multi_stage")
          obj['discountData'] = this.responses.discountResponseData
        if (this.dueName && this.dueName.workflow_stage == "multi_stage")
          obj['dueData'] = this.responses.dueResponseData
        if (this.paymentForm.controls['due_amount'] && this.paymentForm.controls['due_amount'].value)
          obj["flow_amount_due"] = this.paymentForm.controls['due_amount'].value
        if (this.paymentForm.controls['discount'] && this.paymentForm.controls['discount'].value)
          obj['flow_amount_discount'] = this.paymentForm.controls['discount'].value
        if ((event == "createBillApprove" || event == 'printBillApprove') && this.dataSet.result_approve_billing) {
          obj['obj_details'] = this.dataSet.result_approve_billing
        }
        if (this.paymentForm.controls['remarks'].value == '' && (!this.showPaymentdeails || this.paymentForm.controls['recovery'].value)) {
          this.navVar[6].default_open = true;
          this.alertService.error("Remarks can not be blank");
          this.createDisable = false;
          return
        }

        if (this.paymentForm.controls['recovery'].value == '' && this.paymentForm.controls['noOfInstallment'].value) {
          this.navVar[5].default_open = true;
          this.alertService.error("Employee Recovery can not be blank");
          this.createDisable = false;
          return
        }

        this.createBillButton.emit(obj);
      } else if (!this.amounts.is_due && this.paymentForm.invalid && this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID') {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event, "recovery_uhId": this.rec_uhId, "recovery_empId": this.rec_employeeId, "rec_name": this.rec_name, "isrecovery": (this.paymentForm.controls['noOfInstallment'].value && this.paymentForm.controls['recovery'].value) ? true : false });
      } else {
        if (this.paymentForm.controls['discount_authorized_by'].status == 'INVALID' && this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID' && this.paymentForm.controls['remarks'].status == 'INVALID') {
          if(this.patientInfo.patient_type != 'IP'){
            this.navVar[2].default_open = true;
          }
          this.navVar[5].default_open = true;
          this.navVar[6].default_open = true;
          this.alertService.error("Discount by and Remarks can not be blank");
          this.createDisable = false;
        }
        else if (this.paymentForm.controls['discount_authorized_by'].status == 'INVALID' && this.paymentForm.controls['remarks'].status == 'INVALID') {
          if(this.patientInfo.patient_type != 'IP'){
            this.navVar[2].default_open = true;
          }
          this.navVar[6].default_open = true;
          this.alertService.error("Discount by and Remarks can not be blank");
          this.createDisable = false;
        }
        else {
          if (this.paymentForm.controls['recovery'].value == '' && this.paymentForm.controls['noOfInstallment'].value) {
            this.navVar[5].default_open = true;
            this.alertService.error("Employee Recovery can not be blank");
            this.createDisable = false;
          }
          if (this.paymentForm.controls['noOfInstallment'].status == 'INVALID') {
            this.navVar[5].default_open = true;
            this.alertService.error("No. of installment can not be blank");
            this.createDisable = false;
          }

          if (this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID') {
            this.navVar[5].default_open = true;
            this.alertService.error("Due by can not be blank");
            this.createDisable = false;
          }
          if (this.paymentForm.controls['discount_authorized_by'].status == 'INVALID') {
            // this.navVar[2].default_open = true;
            this.alertService.error("Discount by can not be blank");
            this.createDisable = false;
            if(this.patientInfo.patient_type != 'IP'){
              this.navVar[2].default_open = true;
            }
          }
          if (this.paymentForm.controls['remarks'].status == 'INVALID') {
            this.navVar[6].default_open = true;
            this.alertService.error("Remarks can not be blank");
            this.createDisable = false;
          }

        }
        // else if(this.paymentForm.controls['remarks'].status == 'INVALID')
        // this.alertService.error("Remarks can not be blank");
      }
    }
  }
  bookOrder(event) {
    if (this.paymentForm && this.paymentForm.controls && this.paymentForm.controls['used_deposit_amount'] && this.paymentForm.controls['used_deposit_amount'].value > 0 && this.paymentForm.controls['used_deposit_amount'].status == "INVALID")
    {
    this.alertService.error("Please enter valid Used Deposit Amount.");
    return;
    }
    if (this.dataSet && this.dataSet.transaction_type != 'OP Billing') {
      this.bookDisable = true;
      setTimeout(() => {
        this.bookDisable = false;
      }, 3000)
    }
    else
      this.bookDisable = true;
    this.paymentForm.controls['is_visible'].setValue(true);
    if (this.paymentForm.controls['is_discount'].value) {
      if (this.discount_remark_mandatory_config_value) {
        if (this.paymentForm.controls['discount_reason'].value == "" || this.paymentForm.controls['discount_reason'].value == undefined) {
          this.alertService.error("Please select Discount Reason");
          this.createDisable = false;
          this.bookDisable = false;
          return;
        }
      }
    }

    if (this.paymentForm.controls['is_due'].value) {
      if (this.due_remark_mandatory_config_value) {
        if (this.paymentForm.controls['due_reason'].value == "" || this.paymentForm.controls['due_reason'].value == undefined) {
          this.alertService.error("Please select Due Reason");
          this.createDisable = false;
          this.bookDisable = false;
          return;
        }
      }
    }
    if ((this.amounts.otp_required && !this.amounts.otp_verified && (this.visible_is_due || this.otp_visibility)) || ((this.visible_is_due || this.otp_visibility) && this.amounts.otp_required_due && !this.amounts.otp_verified_due)) {
      this.alertService.error("Please verify OTP and proceed");
    } else {
      if (this.amounts.is_due) {
        if (this.paymentForm.controls['due_amount'].value <= 0) {
          this.resetDueCheckbox();
        }
      }
      if (this.paymentForm.controls['is_used_deposit'].value && this.paymentForm.controls['used_deposit_amount'].value <= 0) {
        this.paymentForm.controls['is_used_deposit'].setValue(false);
      }
      let sum = 0;
      this.paymentForm.controls['payment_detail'].value.forEach(element => {
        sum += element.received_amount;
      });
      this.paymentForm.controls['received_amount'].setValue(sum);
      if (event == 'cancel') {
        this.createBillButton.emit({ "button": event });
      } else if (this.paymentForm.valid) {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event });
      } else if (!this.amounts.is_due && this.paymentForm.invalid && this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID') {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event });
      } else {
        // this.alertService.error("Please fill required fields");
      }
      if (event == "bookOrder") {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event, "isCall": true });
      }
    }
  }
  draftOrder(event) {
    if (this.paymentForm && this.paymentForm.controls && this.paymentForm.controls['used_deposit_amount'] && this.paymentForm.controls['used_deposit_amount'].value > 0 && this.paymentForm.controls['used_deposit_amount'].status == "INVALID")
    {
    this.alertService.error("Please enter valid Used Deposit Amount.");
    return;
    }
    if (this.dataSet && this.dataSet.transaction_type != 'OP Billing') {
      this.draftDisable = true;
      setTimeout(() => {
        this.draftDisable = false;
      }, 3000)
    }
    else
      this.draftDisable = true;
    this.paymentForm.controls['is_visible'].setValue(true);
    if (this.paymentForm.controls['is_discount'].value) {
      if (this.discount_remark_mandatory_config_value) {
        if (this.paymentForm.controls['discount_reason'].value == "" || this.paymentForm.controls['discount_reason'].value == undefined) {
          this.alertService.error("Please select Discount Reason");
          this.createDisable = false;
          this.draftDisable = false;
          return;
        }
      }
    }

    if (this.paymentForm.controls['is_due'].value) {
      if (this.due_remark_mandatory_config_value) {
        if (this.paymentForm.controls['due_reason'].value == "" || this.paymentForm.controls['due_reason'].value == undefined) {
          this.alertService.error("Please select Due Reason");
          this.createDisable = false;
          this.draftDisable = false;
          return;
        }
      }
    }

    if ((this.amounts.otp_required && !this.amounts.otp_verified && (this.visible_is_due || this.otp_visibility)) || ((this.visible_is_due || this.otp_visibility) && this.amounts.otp_required_due && !this.amounts.otp_verified_due)) {
      this.alertService.error("Please verify OTP and proceed");
    } else {
      if (this.amounts.is_due) {
        if (this.paymentForm.controls['due_amount'].value <= 0) {
          this.resetDueCheckbox();
        }
      }
      if (this.paymentForm.controls['is_used_deposit'].value && this.paymentForm.controls['used_deposit_amount'].value <= 0) {
        this.paymentForm.controls['is_used_deposit'].setValue(false);
      }
      let sum = 0;
      this.paymentForm.controls['payment_detail'].value.forEach(element => {
        sum += element.received_amount;
      });
      this.paymentForm.controls['received_amount'].setValue(sum);
      if (event == 'cancel') {
        this.createBillButton.emit({ "button": event });
      } else if (this.paymentForm.valid) {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event });
      } else if (!this.amounts.is_due && this.paymentForm.invalid && this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID') {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event });
      } else {
        // this.alertService.error("Please fill required fields");
      }
      if (event == "draftOrder") {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event, "isCall": true });
      }
    }
  }
  valueChangeStart(e: any, obj) {
    
    this.objval = obj;
    if (obj.form.controls['payment_mode_code'].value == "cash" && obj.form.controls['bank_code'].question_component != undefined) {
      obj.form.controls['bank_code'].question_component.question.visible = false;
    }
    if (obj.form.controls['bank_code'].question_component) {
      if (obj.form.controls['payment_mode_code'] != undefined) {
        if (obj.form.controls['payment_mode_code'].value == "cheque" || obj.form.controls['payment_mode_code'].value == "dd" || obj.form.controls['payment_mode_code'].value == "rtgs" || obj.form.controls['payment_mode_code'].value == "neft") {
          if (obj.form.controls['bank_code'] != undefined)
            obj.form.controls['bank_code'].question_component.question.required = true;
        }
        else
          obj.form.controls['bank_code'].question_component.question.required = false;
      }
    }
    if (obj.form.controls['payment_mode_code'] != undefined && obj.form.controls['payment_mode_code'].value == "pos" && obj.form.controls['integrated_pos_machine'] && obj.form.controls['integrated_pos_machine'].value == 'integrated_pos') {
      if (obj.form.controls['transaction_no'] && obj.form.controls['transaction_no'].question_component) {
        obj.form.controls['transaction_no'].question_component.question.disabled = true
      }
    } else {
      if (obj.form.controls['transaction_no'] && obj.form.controls['transaction_no'].question_component) {
        obj.form.controls['transaction_no'].question_component.question.disabled = false
      }
    }

  }
  beforeSubmitValidation() {
    if (this.objval.form.controls['payment_mode_code'].value == "cheque" || this.objval.form.controls['payment_mode_code'].value == "dd" || this.objval.form.controls['payment_mode_code'].value == "rtgs" || this.objval.form.controls['payment_mode_code'].value == "neft") {
      if (this.objval.form.controls['bank_code'].value == "") {
        this.formService.alerts.error("Paid Through can't be blank.")
        return false;
      }
    }
    if (this.objval.form.controls['payment_mode_code'].value!= "cash" && this.objval.form.controls['transaction_no'].value == "" && this.dataSet.transaction_type == 'Pharmacy Billing' && !this.objval.form.controls['transaction_no'].question_component.question.disabled) {
      this.formService.alerts.error("Transaction no can't be blank.")
      return false;
    }
    else
      return true;
  }
  customPatternapplid() {
    if (this.configValueDecimal == "No") {
      return "^[0-9+]*$"
    }
    else {
      return "^\\d{1,9}(\\.\\d{1,2})?$"
    }
  }
  valueChangeEnd(e: any, obj) {
    PaymentModeFlagsDecorator.applyFlags(e, obj);
    PaymentModeFlagsDecorator.hideGridColumns(this.compositeArrayComponent);
    if(this.enablePaymentMode && this.paymentTotalEditable!=0){
      if(obj.form.controls['payment_mode_code']!=undefined && obj.form.controls['payment_mode_code'].question_component!=undefined && obj.form.controls['payment_mode_code'].question_component.question!=undefined && obj.form.controls['amount']!=undefined && obj.form.controls['amount'].question_component!=undefined && obj.form.controls['amount'].question_component.question!=undefined){
      //  && obj.form.controls['amount']!=undefined){
        obj.form.controls['payment_mode_code'].question_component.question.disabled = false;
        obj.form.controls['amount'].question_component.question.disabled = false;
        obj.form.controls['amount'].setValue(this.paymentTotalEditable);

        
      }
    }
    if (e.question != undefined && e.question.key == "received_amount" && (obj.id == "payment_order_details" || (obj.id == "main" && obj.type == "popup"))) {
      setTimeout(() => {
        if (this.configValueDecimal == "Yes") {
          e.question.pattern = "^\\d{1,9}(\\.\\d{1,2})?$";
          if (obj.form.controls['received_amount'] && obj.form.controls['received_amount'].value != "") {
            this.changeDueAmountDecimal = true;
            var receivedAmountDecimal = Number(obj.form.controls['received_amount'].value);
            // if(this.paymentForm.controls['advance_payment'].value !=""){
            //   receivedAmountDecimal = receivedAmountDecimal - this.paymentForm.controls['advance_payment'].value
            // }
            obj.form.controls['received_amount'].setValue(receivedAmountDecimal.toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));


          }
        } else {
          e.question.pattern = "^[0-9+]*$";
        }
      }, 100);
    }
    if (e != undefined && e.question != undefined && e.question.key != undefined && e.question.key == "payment_mode_code") {
      if (obj.form.controls['payment_mode_code'] != undefined && obj.form.controls['payment_mode_code'].value != "cash" && obj.form.controls['bank_code'] != undefined && obj.form.controls['bank_code'].question_component != undefined) {

        obj.form.controls['bank_name'].status = "VALID";
        obj.form.controls['bank_code'].status = "VALID";
        let data = {
          'args': `payment_mode_code:${obj.form.controls['payment_mode_code'].value},facility_master_type:PAYMENTMODEMAPPING`
        }

        var queryId = "getOrganizationSetup"
        this.formService.baseService.getData(data, "", "facility_master", "facility-management", queryId).subscribe(res => {
          if (res.errCode == 0 && res.resource.length > 0) {
            obj.form.controls['bank_code'].question_component.question.options = res.resource;

          } else {
            obj.form.controls['bank_code'].question_component.question.options = [];
            if (obj.form.controls['bank_name'].value != "") {
              obj.form.controls['bank_name'].setValue("");
              obj.form.controls['bank_name'].status = "VALID";
            }

            if (obj.form.controls['bank_code'].value != "") {
              obj.form.controls['bank_code'].setValue("");
              obj.form.controls['bank_code'].status = "VALID";
            }

          }

        })

      }
    }
  }

  onPaymentRemove(event) {
    let deletedItem = event.itemss[event.index].integrated_pos_machine
    if (deletedItem == 'integrated_pos') {
      let deviceID = this.appService.readCookie('device_id');
      let gateway_transactionId = event.itemss[event.index].transaction_no
      let kx_transactionId = event.itemss[event.index].kx_transaction_no
      let resource = {
        deviceId: deviceID,
        amount: event.itemss[event.index].received_amount,
        uhId: this.patientInfo.uhId,
        extra_data: {
          gateway_transactionId: gateway_transactionId,
          kx_transactionId: kx_transactionId
        }
      }
      this.baseService.action(resource, 'CANCEL_POS_PAYMENT_REQUEST', 'payment-gateway', 'ui_gateway_response').subscribe(response => {
        console.log("Resopnse from payment gateway", response)
        if (response && response.resource && response.resource[0] && response.resource[0].extra_data.responseCode == '200') {
          this.payment_gateway_cancel_response = response.resource[0].extra_data.responseCode
        }
      });
    }
    this.amounts.removedAmount = this.amounts.paidAmount[event.index];
    if (this.amounts.removedAmount == undefined || this.amounts.removedAmount == '') {
      this.amounts.removedAmount = 0;
    }
    this.amounts.paidAmount.splice(event.index, 1);
    if (event.items.length > 0) {
      this.amounts.sum = 0;
      for (let entry of event.items)
        this.amounts.sum += Number(entry.received_amount);
    } else {
      this.amounts.sum = 0;
    }

    if (this.amounts.is_due) {
      this.paymentForm.controls['due_amount'].setValue(Number(this.paymentForm.controls['final_amount'].value - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['net_receivable_payer_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    }
    let patientAmount = this.paymentForm.controls['final_amount'].value;
    this.amounts.netPayableAmount = (patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['due_amount'].value);
    this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
  }

  checkCompositeInputAmt(evt) {
    if (evt.target['valueAsNumber'] > Number(this.amounts.netPayableAmount)) {
      document.getElementsByClassName('kx-w-85')[0]['disabled'] = true;
    } else {
      document.getElementsByClassName('kx-w-85')[0]['disabled'] = false;
    }
  }

  ngOnDestroy() { }

  schemeSetup(value) {
    if (value.type && value.type.toLowerCase() == "scheme" && value.schemeId != undefined && value.schemeId) {
      try {
        console.log("Data ", this.dataSet);
        this.schemeApiSignature['args'] = "";
        // if(this.dataSet.orderedFrom == "Optical Order"){
        //   this.schemeApiSignature['args'] = "applicable_on:CUSTOM_SCHEME"
        // }
        this.loader.showSpinner();
        this.baseService.getByDataSource(this.schemeApiSignature).subscribe(res => {
          this.loader.hideSpinner();
          console.log('scheme api data ==>>', res);
          if (res.errCode == 0 && res.count > 0) {
            // this.responses.schemeResponse = res.resource;
            this.paymentForm.controls['scheme'].setValue(value.schemeId);
          }
        })
      } catch (e) {
        console.error('Error => ', e);
      }
      this.visibility.discountFieldVisible = false;
      this.visibility.schemeVisible = true;
      this.scheme_selected = true;
      this.visibility.schemeVisible = true;
      this.scheme_idd = value.schemeId;
    }
  }

  showHideAcc(value){
    if (value && value.hasOwnProperty('hide_sections') && this.navVar.length > 0) {
      for (let f of this.navVar) {
        if (f.block_id == 'discount' && value.hasOwnProperty('discount_component')) {
          f.show = value.discount_component;
        }
        if (f.block_id == 'deposit' && value.hasOwnProperty('deposite_component')) {
          f.show = value.deposite_component;
        }
        if (f.block_id == 'advance' && value.hasOwnProperty('advance_component')) {
          f.show = value.advance_component;
        }
        if (f.block_id == 'due' && value.hasOwnProperty('due_component')) {
          f.show = value.due_component;
        }
        if (f.block_id == 'remarks' && value.hasOwnProperty('remarks_component')) {
          f.show = value.remarks_component;
        }
        if (f.block_id == 'delivery_charges' && value.hasOwnProperty('charges_component')) {
          f.show = value.charges_component;
        }
      }
    }
  }

  checkCreatebill() {
    if (this.config != undefined && this.config.checkCreatebill != undefined) {
      let configdate = moment(this.config.deliveryDate).format("MMM Do YY");
      let currentdate = moment(new Date().getTime()).format("MMM Do YY");
      let batchflag = true;//this.config.items != undefined && this.config.items.length != undefined ? (this.config.items.find(x => !x.batchNo && (x.itemCategory.toLowerCase() != 'coating' || x.itemCategory.toLowerCase() != "glass" || x.itemCategory.toLowerCase() != "contact lens" || x.itemCategory.toLowerCase() != "lens")) ? true : false) : false;
      if (this.config.showDetails) {
        this.showHideAcc(this.config.showDetails);
      }
      if (this.config.items && this.config.items.filter(x => !x.batchNo).length > 0) {
        batchflag = false
      }
      return (this.paymentForm.controls['net_receivable_amount'].value === 0) && (configdate === currentdate) && (batchflag) ? true : false;

    } else { return true }
  }

  getConfigOverridScheme() {
    this.loader.showSpinner()
    if (this.dataSet && this.dataSet.op_amount_value && (this.dataSet.op_amount_value.orderedFrom == "IPD Clinical Order" || this.dataSet.op_amount_value.orderedFrom == "IPD_CLINICAL_BILLING_AUTH_CLEARANCE")){
      this.baseService.get("GET_CONFIG", `config_code:billing_827,module_code:billing`, "facility_config_mapping", "facility-management").subscribe((config: any) => {
        this.loader.hideSpinner();
        if (config.errCode == 0 && config.resource.length > 0 && config.resource[0].config_value == "yes") {
          this.override_config = false;
        }
      })
    }
    else {
      this.baseService.get("GET_CONFIG", `config_code:billing_827,module_code:billing`, "facility_config_mapping", "facility-management").subscribe((config: any) => {
        this.loader.hideSpinner();
        if (config.errCode == 0 && config.resource.length > 0 && config.resource[0].config_value == "yes") {
          this.override_config = true;
        }
      })
    }
  }


  updateBill(event) {
    if ((this.amounts.otp_required && !this.amounts.otp_verified && (this.visible_is_due || this.otp_visibility)) || ((this.visible_is_due || this.otp_visibility) && this.amounts.otp_required_due && !this.amounts.otp_verified_due)) {
      this.alertService.error("Please verify OTP and proceed");
      this.createDisable = false;
    } else {
      // if (this.amounts.is_due) {
      //   if (this.paymentForm.controls['due_amount'].value <= 0) {
      //     // this.resetDueCheckbox();
      //   }
      // }
      // if (this.paymentForm.controls['is_used_deposit'].value && this.paymentForm.controls['used_deposit_amount'].value <= 0) {
      //   this.paymentForm.controls['is_used_deposit'].setValue(false);
      // }
      let sum = 0;
      if (this.paymentForm.controls['payment_detail'].value != null) {
        this.paymentForm.controls['payment_detail'].value.forEach(element => {
          if (this.configValueDecimal == "Yes") {
            let receivedAmount = Number(element.received_amount);
            sum += receivedAmount;
          } else {
            sum += element.received_amount;
          }
        });
      }
      this.paymentForm.controls['received_amount'].setValue(sum);
      // if (event == 'cancel') {
      //   this.createBillButton.emit({ "button": event });
      // } else 
      if (this.paymentForm.valid) {
        // if (this.paymentForm.controls['noOfInstallment'].value == 0) {
        //   this.navVar[5].default_open = true;
        //   this.alertService.error("No. of installment can not be 0");
        //   this.createDisable = false;
        //   return;
        // } let Arr = []; let emtArr = [];
        let obj = { "payment": this.paymentForm.getRawValue(), "button": event, "recovery_uhId": this.rec_uhId, "recovery_empId": this.rec_employeeId, "rec_name": this.rec_name, "isrecovery": (this.paymentForm.controls['noOfInstallment'].value && this.paymentForm.controls['recovery'].value) ? true : false, discountData: this.discountData, dueData: this.dueName, hasTotalAmount: this.paymentForm.controls.total_amount.value }

        // if (this.discountData && this.discountData.workflow_stage == "single_stage") {
          // Arr.push(this.discountData)
          // obj['discountData'] = Arr
        // }
        // if (this.dueName && this.dueName.workflow_stage == "single_stage") {
          // emtArr.push(this.dueName)
          // obj['dueData'] = emtArr;
        // }
        // if (this.discountData && this.discountData.workflow_stage == "multi_stage")
        //   obj['discountData'] = this.responses.discountResponseData
        // if (this.dueName && this.dueName.workflow_stage == "multi_stage")
        //   obj['dueData'] = this.responses.dueResponseData
        // if (this.paymentForm.controls['due_amount'] && this.paymentForm.controls['due_amount'].value)
        //   obj["flow_amount_due"] = this.paymentForm.controls['due_amount'].value
        // if (this.paymentForm.controls['discount'] && this.paymentForm.controls['discount'].value)
        //   obj['flow_amount_discount'] = this.paymentForm.controls['discount'].value
        // if (event == "createBillApprove" || event == 'printBillApprove') {
        //   obj['obj_details'] = this.dataSet.result_approve_billing
        // }
        if (this.paymentForm.controls['remarks'].value == '' && !this.showPaymentdeails) {
          this.navVar[6].default_open = true;
          this.alertService.error("Remarks can not be blank");
          this.createDisable = false;
          return
        }

        // if (this.paymentForm.controls['recovery'].value == '' && this.paymentForm.controls['noOfInstallment'].value) {
        //   this.navVar[5].default_open = true;
        //   this.alertService.error("Employee Recovery can not be blank");
        //   this.createDisable = false;
        //   return
        // }

        this.createBillButton.emit(obj);
      } 
      // else if (!this.amounts.is_due && this.paymentForm.invalid && this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID') {
      //   this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event, "recovery_uhId": this.rec_uhId, "recovery_empId": this.rec_employeeId, "rec_name": this.rec_name, "isrecovery": (this.paymentForm.controls['noOfInstallment'].value && this.paymentForm.controls['recovery'].value) ? true : false });
      // }
      else {
        // if (this.paymentForm.controls['discount_authorized_by'].status == 'INVALID' && this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID' && this.paymentForm.controls['remarks'].status == 'INVALID') {
        //   this.navVar[2].default_open = true;
        //   this.navVar[5].default_open = true;
        //   this.navVar[6].default_open = true;
        //   this.alertService.error("Discount by and Remarks can not be blank");
        //   this.createDisable = false;
        // }
        // // else if (this.paymentForm.controls['discount_authorized_by'].status == 'INVALID' && 
        // else if(this.paymentForm.controls['remarks'].status == 'INVALID') {
        //   this.navVar[2].default_open = true;
        //   this.navVar[6].default_open = true;
        //   this.alertService.error("Discount by and Remarks can not be blank");
        //   this.createDisable = false;
        // }
        // else {
        // if (this.paymentForm.controls['recovery'].value == '' && this.paymentForm.controls['noOfInstallment'].value) {
        //   this.navVar[5].default_open = true;
        //   this.alertService.error("Employee Recovery can not be blank");
        //   this.createDisable = false;
        // }
        // if (this.paymentForm.controls['noOfInstallment'].status == 'INVALID') {
        //   this.navVar[5].default_open = true;
        //   this.alertService.error("No. of installment can not be blank");
        //   this.createDisable = false;
        // }

        // if (this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID') {
        //   this.navVar[5].default_open = true;
        //   this.alertService.error("Due by can not be blank");
        //   this.createDisable = false;
        // }
        // if (this.paymentForm.controls['discount_authorized_by'].status == 'INVALID') {
        //   this.navVar[2].default_open = true;
        //   this.alertService.error("Discount by can not be blank");
        //   this.createDisable = false;
        // }
        if (this.paymentForm.controls['remarks'].status == 'INVALID') {
          this.navVar[1].default_open = true;
          this.alertService.error("Remarks can not be blank");
          this.createDisable = false;
        }

      }
    }
  }

}